import { Component, OnInit } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators, FormControl } from '@angular/forms';
import { BusinessDayService } from '../../services/business-day.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SWAlertService } from '../../services/swalert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/public_api';
import Swal from 'sweetalert2';
import { isNullOrUndefined, isUndefined, isNull } from 'util';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { async } from '@angular/core/testing';
import * as _ from 'lodash';
declare var Uploadfiles, Clearuploadfile, SetData, _Path, Extension: any, Accept: any
declare var ArrFile: any[];


@Component({
  selector: 'app-pettycash',
  templateUrl: './pettycash.component.html',
  styleUrls: ['./pettycash.component.css']
})
export class PettycashComponent implements OnInit {
  //#region Set default
  PettycashFrom: FormGroup;
  sDate = new Date();
  minDate: Date;
  maxDate: Date;
  Todate: Date;
  currencyChars = new RegExp('[\,]', 'g');
  holidays: Date[] = []; //ตัวแปรรับค่า holiday
  DataEmployee: any;
  DataRequest: any;
  DataType: any;
  DataVander: any;
  DataReqItem: any;
  DataVat: any;
  DataGL: any;
  DataCostCenter: any;
  DataBank: any;
  _DataBank: any;
  masterBankBranch: any[] = [];
  BankBranch: any[] = [];
  masterBankAccountNo: any[] = [];
  BankAccountNo: any[] = [];
  _BankBranch: any;
  _BankAccountNo: any;
  DataIO: any[] = [];
  DataFlow: any;
  WithholdingTax: any;
  DataApprove1: any[] = [];
  DataApprove2: any[] = [];
  MonneyType: any;
  ArrVander: any[] = [];
  ArrType: any[] = [];
  ArrEmployee: any[] = [];
  ArrRequest: any[] = [];
  DataVendor_NoPE: any[] = [];
  Name_DataVendor: any[] = [];
  name: string;
  hVatAmount: boolean;
  hVatAmount2: boolean;
  IsNoData: boolean;
  IsNew: boolean = true;
  noResult = false;
  selectedValue: string;
  ResultPermission: boolean;
  selectedOption: any;
  sComCode = 388;
  IsIO: boolean = true;
  IsGL: boolean = true;
  TAttachedFiles: any[] = [];
  RateWHTax: any;
  sID: string = "";
  fieldsetDisabled: boolean;
  nStatus: number = 1;
  BuArea: string = null;
  arrBuArea: any;
  IsbtnAdd: boolean = false;
  IsbtnInvoiceAdd: boolean = false;
  IsbtnInvoiceClear: boolean = false;
  IsView: boolean = false;
  ContactID: any;
  sReqCode: string;
  IssReqCode: boolean = false;
  sComment: any;
  sCommentSSC: any;
  isReject: boolean = false;
  Iscomment: boolean = false;
  clicked: boolean  = false;

  olddate: any;
  VendorCode: any;
  ArrTransactionHistory: any;
  IsNoDataTrans: boolean = true;
  //#endregion
  //#region Set FormControl
  fileType: any;
  limitFile: any;
  isNewRequest: boolean = false;
  isForROS: boolean = false;
  urgentDay: number = 6;
  get _PettycashFrom() { return this.PettycashFrom.controls; }
  get ArrGL() { return this._PettycashFrom.ArrGL as FormArray; }//Dynamic
  //#endregion
  _HolidayDB = [];
  constructor(private BusinessDay: BusinessDayService, private http: HttpClient
    , private formBuilder: FormBuilder, private SW: SWAlertService
    , private activatedRoute: ActivatedRoute
    , private router: Router
    , private System: TSFuntionService
    , private localeService: BsLocaleService) {
    this.getHoliday();
  }

  async ngOnInit() {
    this.System.BlockUI();
    //set filed in formgroup
    let ua = this.System.GetUserStorage();
    this.sComCode = ua.sCompCode;
    this.ContactID = ua.nUserID;
    this.PettycashFrom = this.formBuilder.group({
      nReqID: ["0"],
      sRole: [ua.nRole],
      dDue: [new Date()],
      sComCode: [ua.sCompCode],
      nUserIDContact: [ua.nUserID],
      sComName: [ua.sCompName],
      txtContactName: [ua.sFullName, Validators.required],
      nContact: [ua.nUserID],
      txtDate: [new Date],
      txtunit: [ua.sUnitName],
      txtEmail: [ua.sEmail, [Validators.pattern("^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$"), Validators.required]],
      txtTel: [ua.sTel],
      txtBU: [""],
      ddlTypeofPay: [40],
      txtCopyofRequestNo: [null, [Validators.required]],
      txtVendorCode: [null, [Validators.required]],
      txtVendorName: [null, [Validators.required]],
      txtTaxID: [null, [Validators.required]],
      cbOffice: [1],
      txtBranchCode: [null],
      txtAddress: [null, [Validators.required]],
      cbVat: [1],
      txtVendorCode_PX: [null, [Validators.required]],
      txtVendorName_PX: [null, [Validators.required]],
      txtTaxID_PX: [null, [Validators.required]],
      cbOffice_PX: [1],
      txtBranchCode_PX: [null],
      txtAddress_PX: [null, [Validators.required]],
      txtInvoice: [null, [Validators.required]],
      txtTotalAmountInvoice: [null],
      ddlUOM: ['THB'],
      txtVatAmount: [null, [Validators.required]],
      txtInvoiceDate: [new Date],
      ddlVatType: [null, [Validators.required]],
      txtTotalAmountVat: [null, [Validators.required]],
      ddlWithholdingTax: ["", [Validators.required]],
      ddlWithholdingTax2: ["", [Validators.required]],
      txtWHTOther: [null, [Validators.required]],
      txtWHTOther2: [null, [Validators.required]],
      nWHTBase: [null],
      nWHTBase2: [null],
      txtWHTAmount: [null],
      _txtWHTAmount: [null],
      txtWHTAmount2: [null],
      _txtWHTAmount2: [null],
      _cbChequeType: [2],
      ddlBank: ['', [Validators.required]],
      lblBankAccountName: ["", [Validators.required]],
      txtBankAccountNo: [null, [Validators.required]],
      txtBankBranch: [null, [Validators.required]],
      lblGrandTotalVat: ['0.00'],
      lblGrandTotalExcludedVAT: ['0.00'],
      lblGrandTotalIncluded: ['0.00'],
      lblGrandTotalWHD: ['0.00'],
      lblAlertMsg: [null],
      txtApprove1: [null, [Validators.required]],
      txtApprove2: [null, [Validators.required]],
      chkApprove1: [null],
      nUserID1: [null],
      nUserID2: [null],
      nStatus: 0,
      Bankother: [null, [Validators.required]],
      ArrGL: new FormArray([
        new FormGroup({
          txtGL: new FormControl('', Validators.required),
          txtCostCenter: new FormControl('', Validators.required),
          txtAmountExcludedVAT: new FormControl('', Validators.required),
          txtText: new FormControl('', Validators.required),
          txtIO: new FormControl('', Validators.required),
          IsDelete: new FormControl(false)
        })
      ]),
      sCountryID: ['213'],
      sCountryName: [null, [Validators.required]],
      sProvCode: [null],
      sProvName: [null, [Validators.required]],
      sAmpCode: [null],
      sAmpName: [null, [Validators.required]],
      sTumbonCode: [null],
      sTumbonName: [null, [Validators.required]],
      sPostCode: [null],
      sPhoneNumber: [null],
      sFaxNumber: [null],
      sVendorEmail: [null, [Validators.email, Validators.pattern("^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$")]],
      sVendorAddress: [null,],
      sComment: [null],
      sCommentSSC: [null],
    });
    this.PettycashFrom.get('txtBankAccountNo').disable();
    await this.setform();
    await this.getFileType();
    await this.getFileLimit();
    await this.getHoliday();
    await this.GetAutocompleteUser();
    await this.GetAutocompleteType();
    await this.GetAutocompleteTRequest();
    //await this.GetAutocompleteTRequestItem();
    await this.GetAutocompleteVatType();
    await this.GetSystemConfigData();
    this.hVatAmount = false;
    this.IsNoData = true;
    this.GetAutocompleteBank();
    await this.GetAutocompleteBankBranch();
    await this.GetAutocompleteBankAccountNo();
    await this.GetAutocompleteWithholdingTax();
    await this.GetAutocompleteIO();
    await this.GetAutocompleteCountry()
    await this.GetAutocompleteProvince();
    this.DataIO.push([]);
    await this.SetData();
    ArrFile.length = 0;
    var setUp = {
      sID: "dvUploadFile",
      nFileSize: 15,
      Accepts: Accept.GetFix(this.fileType),
      Extensions: Extension.GetFix(this.fileType),
      ModeMulti: true,
      ArrFile: ArrFile,
      View: false,
      HasURL: true,
      UrlUpload: this.System.SiteName + _Path.PathUpload,
      limit: this.limitFile,
    };
    Uploadfiles(setUp);
    Clearuploadfile();
  }
  checkFile() {
    if (ArrFile.filter(f => f.IsDelete === false).length > 0) {
      const chkFile =  document.getElementById('dv_dvUploadFile');
      chkFile.style.border = '1px solid #dde4f6';
    }
    return '';
  }
  async getFileType() {
    await this.http.get(this.System.SiteName + 'api/FileConfig/FileType').toPromise().then((data: Response) => {
      const result = [];
      const item = Object.values(data);
      for (let x = 0; x < item.length; x++ ) {
        if (data[x]['sValue'] === 'Y') {
          result.push(data[x]['sValueText']);
        }
      }
      this.fileType = result;
    });
  }
  async getFileLimit() {
    await this.http.get(this.System.SiteName + 'api/FileConfig/FileLimit').toPromise().then((data: Response) => {
      const result = [];
      const item = Object.values(data);
      for (let x = 0; x < item.length; x++ ) {
        result.push(data[x]['sValue']);
      }
      this.limitFile = result;
    });
  }
  bsConfig: Partial<BsDatepickerConfig>;
  //Load data by ID from URL
  //check Due date
  //#region Set Calendar Due Date
  async SetData() {
    //get ID from URL
    let ID: string = this.System.GetQuerySTR('str');
    let ID2: string = this.System.GetQuerySTR('ros');
    this.sID = await this.System.Decrypt(ID);
    if (ID2 !== 'undefined') {
      this.sID = await this.System.Decrypt(ID2);
      this.isForROS = true;
      this.urgentDay = 8;
    }
    if(this.sID === ''){
      this.isNewRequest = true;
    }
    let ua = this.System.GetUserStorage(); //get User Login
    if (ua.IsROService && this.isForROS) {
      this.isReject = true;
    }
    //Check Permission
    let ObjData = {
      sRequestID: this.sID,
      nMenuID: 9
    }
    this.ResultPermission = await this.System.CheckPermission(ObjData);
    this.IsIO = await this.System.GetCompanyUSEIO(ObjData);
    this.IsGL = await this.System.GetCompanyUSEGL(ObjData);
    //Set Mode View
    if (!this.ResultPermission) {
      this.PettycashFrom.disable();
      this.IsbtnAdd = true;
      this.IsbtnInvoiceAdd = true;
      this.IsbtnInvoiceClear = true;
      this.isPrint = this.sID == "" ? false : true;
      this.isSubmit = false;
      this.isDraf = false;
      this.isCencal = false;
      this.isRecall = false;
      this.IsView = true;

    } else {
      //this.IsView = true;
    }
    //if sID is not null
    if (this.sID != "" && !this.isForROS) {
      this.onTReqbyID(this.sID);
      this.getFlowPro(this.sID);
    } else {
      this.Todate = this.BusinessDay.SetToday(this.holidays);
      this.minDate = this.BusinessDay.SetToday(this.holidays);
      this.minDate.setDate(this.minDate.getDate() + 1);
      this.minDate = this.BusinessDay.SetNextDate(this.minDate, this.holidays)
      this.PettycashFrom.patchValue({ dDue: this.minDate });

      if (!this.isNewRequest) {
        let data: any;
        await this.http.get(this.System.SiteName + "api/ROService/GetRequest/" + this.sID + "").toPromise().then(Data => data = Data)
        if(data != null){
          this.PettycashFrom.patchValue({
            nReqID: data[0].sRequestID,
            sComment: data[0].sComment,
            sCommentSSC: `Expected Complete Date : ${data[0].dExpectedCompleteDate}${data[0].sRemarkSSC ? `\n${data[0].sRemarkSSC}` : ''}`,
          });
          this.sComment = data[0].sComment;
          this.sCommentSSC = data[0].sRemarkSSC;
          this.onSelectContact2(data[0].sFullName);
  
        }
        this.http.get<any>(this.System.SiteName + "api/PaytoEmployee/GetFle/" + this.sID).subscribe(res => {
          let data = res;
          if (data) {
            let arrdata: any[] = [];
            data.forEach(f => arrdata.push({
              nID: f.nFileOrder,
              sPath: f.sPathFile,
              sSystemFileName: f.sSystemFileName,
              sFileName: f.sFileName,
              sSize: parseInt(f.sFileSize)
            }))
            SetData("dvUploadFile", arrdata)
          }
    
        });
      }

      this.handler();
    }
    this.System.UnBlockUI();
  }
  //#endregion
  //check Due date
  //#region Set Calendar Due Date
  message = '';
  IsReqUrgent: number;
  handler(): void {
    //get value dDue formControlName
    var Duedate = this.PettycashFrom.get('dDue').value;
    let date = Intl.DateTimeFormat('en').format(Duedate);
    let _date = new Date(date)
    //if property doesn't match then do this
    var check_date = this.BusinessDay.setDueDatebyDate(this.Todate, _date, this.holidays);
    if (check_date < this.urgentDay) {
      this.message = 'You have ' + check_date + ' working days before due date. This is "Urgent" payment.'
      this.IsReqUrgent = 1;
      //this.nUrgentDate = check_date < 0 ? 0 : check_date
      this.nUrgentDate = check_date
    } else {
      this.message = "";
      this.IsReqUrgent = 0;
      this.nUrgentDate = check_date
    }
  }
  //#endregion

  //set file
  //#region Set default FormControl
  async setform() {
    this.checkOffice();
    this.checkOffice_PX();
    this.cbVATorWHT();
    this.GetAutocompleteGL();
    this.GetAutocompleteCostCenter();
    this.GetAutocompleteMT_Vendor();
    this.GetAutocompleteVendorNoPE();
    this.GetAutocompleteGetVendorOneTime();
    this.GetBuArea();

  }
  //#endregion

  ApproveName1: any;
  ApproveCode1: any;
  ApproveName2: any;
  ApproveCode2: any;

  //#region set LoadData & AutoComplete
  //#region "GetAutocompleteFlow"
  GetAutocompleteFlow() {
    let arr: any;
    let arr_ap: any;
    let _Flow1: any[];
    let _Flow2: any[];
    if (!this.ReqID) {
      this.http.get(this.System.SiteName + "api/Autocomplete/TM_Flows/*/sCompCode/" + this.sComCode).subscribe((data: Response) => {
        if (data) {
          arr = data
          arr_ap = arr.filter(data => data.nReqType == 40);
          if (arr_ap.length === 0) return;
          _Flow1 = this.DataEmployee.filter(data => data.cActive === 'Y' && data.nUserID == arr_ap[0].nApproveID1);
          _Flow2 = this.DataEmployee.filter(data => data.cActive === 'Y' && data.nUserID == arr_ap[0].nApproveID2);
          if (arr_ap[0].cActive == "N") {
            this.PettycashFrom.patchValue({
              txtApprove1: null
              , nUserID1: 0
              , txtApprove2: null
              , nUserID2: 0
            })

            this.isSkip = false;
          } else {
              if (arr_ap[0].IsApprover_1 == true) {
                this.ApproveName1 = _Flow1[0].sName + " " + _Flow1[0].sSurName
                this.ApproveCode1 = _Flow1[0].nUserID
                this.PettycashFrom.patchValue({ txtApprove1: _Flow1[0].sName + " " + _Flow1[0].sSurName })
                this.PettycashFrom.patchValue({ nUserID1: _Flow1[0].nUserID })
              } else {
                this.ApproveCode1 = _Flow1.length > 0 ? _Flow1[0].nUserID : 0
                this.PettycashFrom.patchValue({ nUserID1: this.ApproveCode1, chkApprove1: true })
                this.PettycashFrom.get('txtApprove1').disable();
                this.isSkip = true;
              }
              if (_Flow2.length != 0) {
                if (arr_ap[0].IsApprover_2 == true) {
                  this.ApproveName2 = _Flow2[0].sName + " " + _Flow2[0].sSurName
                  this.ApproveCode2 = _Flow2[0].nUserID
                  this.PettycashFrom.patchValue({ txtApprove2: _Flow2[0].sName + " " + _Flow2[0].sSurName })
                  this.PettycashFrom.patchValue({ nUserID2: _Flow2[0].nUserID })
                } else {
                  this.ApproveCode2 = _Flow2[0].nUserID
                  this.PettycashFrom.patchValue({ nUserID2: _Flow2[0].nUserID })
                }
              }
          }
        }

      })
    }
  }
  //#endregion

  //#region "GetAutocompleteUser"
  async GetAutocompleteUser() {
    let arr: any;
    let arr_ap: any;
    await this.http.get(this.System.SiteName + "api/Autocomplete/TUserpermission/*/sCompCode/" + this.sComCode).toPromise().then((data: Response) => {
      this.DataEmployee = data != null ? data : [];
      arr = this.DataEmployee.filter(data => data.nRole == 5);
      arr.map(data => this.ArrEmployee.push({ name: data.sName + " " + data.sSurName, UserID: data.nUserID }))
      arr_ap = this.DataEmployee.filter(data => data.cActive === 'Y' && data.nRole == 3);
      arr_ap.map(data => this.DataApprove1.push({ name: data.sName + " " + data.sSurName, UserID: data.nUserID }))
      arr_ap = this.DataEmployee.filter(data => data.cActive === 'Y' && data.nRole == 4);
      arr_ap.map(data => this.DataApprove2.push({ name: data.sName + " " + data.sSurName, UserID: data.nUserID }))

    })
  }
  //#endregion

  //#region "GetAutocompleteType"
  async GetAutocompleteType() {
    this.ArrType = [];
    await this.http.get(this.System.SiteName + "api/Autocomplete/TM_RequestType/*").toPromise().then((data: Response) => {
      this.DataType = data != null ? data : [];
    })
  }
  //#endregion

  //#region "GetAutocompleteTRequest"
  async GetAutocompleteTRequest() {
    this.ArrRequest = [];
    await this.http.get(this.System.SiteName + "api/PettyCash/getCopyReq/" + this.sComCode).toPromise().then((data: Response) => {
      if (data) {
        this.DataRequest = data;
      }
      this.GetAutocompleteFlow();
    })

  }
  //#endregion

  //#region "GetAutocompleteMT_Vendor"
  async GetAutocompleteMT_Vendor() {
    let ArrRequest = [];
    let Comcode = this.sComCode
    await this.http.get(this.System.SiteName + "api/PettyCash/GetEmployee/" + Comcode).toPromise().then((data: Response) => {
      this.DataVander = data != null ? data : [];
    })

  }
  //#endregion

  //#region "Holiday"
  async getHoliday() {
    //get Holiday from HolidayController
    await this.http.get<any>(this.System.SiteName + "api/PettyCash/GetHoliday").toPromise().then(res => {
      this._HolidayDB = res;
      this.holidays = this._HolidayDB.map(({ dDate }) => new Date(dDate)) //get value from Holidaycontroller
    });
  }
  //#endregion

  //#region "GetAutocompleteTRequestItem"
  async GetAutocompleteTRequestItem() {
    this.ArrRequest = [];
    await this.http.get(this.System.SiteName + "api/Autocomplete/TRequestItems/*").toPromise().then((data: Response) => {
      this.DataReqItem = data != null ? data : [];
      //this.ArrRequest = this.DataRequest.map(re => re.sRequestCode)
    })
  }
  //#endregion

  //#region "GetAutocompleteVatType"
  async GetAutocompleteVatType() {
    await this.http.get(this.System.SiteName + "api/Autocomplete/Like/MT_VATTYPE/*/sReqType/40").toPromise().then((data: Response) => {
      this.DataVat = data != null ? data : [];
    })


  }
  //#endregion

  //#region "GetSystemConfigData"
  async GetSystemConfigData() {
    let arr: any;
    await this.http.get(this.System.SiteName + "api/Autocomplete/MT_CURRENCY/*").toPromise().then((data: Response) => {
      arr = data
      this.MonneyType = data != null ? data : [];
    })
  }
  //#endregion

  //#region "GetAutocompleteGL"
  async GetAutocompleteGL() {
    const httpOptions_GL = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.PettycashFrom.value['sComCode'])
    };
    this.ArrType = [];
    await this.http.get(this.System.SiteName + "api/_System/GetGL", httpOptions_GL).subscribe(Response => {
      this.DataGL = Response != null ? Response : [];
    })
  }
  //#endregion

  //#region "GetAutocompleteCostCenter"
  async GetAutocompleteCostCenter() {
    this.ArrType = [];
    const httpOptions_CostCenter = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.PettycashFrom.value['sComCode'])
    };
    await this.http.get(this.System.SiteName + "api/_System/GetCostCenter", httpOptions_CostCenter).toPromise().then((data: Response) => {
      this.DataCostCenter = data != null ? data : [];
    })
  }
  //#endregion

  //#region "GetAutocompleteBank"
  GetAutocompleteBank() {
    this.ArrType = [];
    this.http.get(this.System.SiteName + "api/Autocomplete/MT_BANK/*/Company/" + this.sComCode).toPromise().then((data: Response) => {
      this.DataBank = data != null ? data : [];
      this._DataBank = this.DataBank;
      if (this._DataBank.length == 1) {
        this.PettycashFrom.patchValue({ ddlBank: this._DataBank[0].BankName })
      }
      this.PettycashFrom.patchValue({ _cbChequeType: 2 })
      this._cbChequeType(2);
    })
  }
  //#endregion

  //#region "GetAutocompleteBankBranch"
  async GetAutocompleteBankBranch() {
    this.ArrType = [];
    //this.http.get(this.System.SiteName + "api/Autocomplete/MT_BANKKEY/(BANK_KEY+' '+NAME_OF_BANK) fullname,*").toPromise().then((data: Response) => {
    //  this.BankBranch = data != null ? data : [];
    //})
    await this.http.get<any>(this.System.SiteName + "api/PettyCash/GetBank").toPromise().then(res => {
      if (res) {
        this.BankBranch = res;
        this.masterBankBranch = res;
      }
    })
  }
  //#endregion

  //#region "GetAutocompleteBankAccounto"
  async GetAutocompleteBankAccountNo() {
    this.ArrType = [];
    //this.http.get(this.System.SiteName + "api/Autocomplete/MT_BANKKEY/(BANK_KEY+' '+NAME_OF_BANK) fullname,*").toPromise().then((data: Response) => {
    //  this.BankBranch = data != null ? data : [];
    //})
    await this.http.get<any>(this.System.SiteName + "api/PettyCash/GetBankAccountNo").toPromise().then(res => {
      if (res) {
        this.BankAccountNo = res;
        this.masterBankAccountNo = res;
      }
    })
  }
  //#endregion

  //#region "GetAutocompleteWithholdingTax"
  async GetAutocompleteWithholdingTax() {
    //_WithholdingTax
    let select = "select * from TM_WHT_Rate where IsActive = 1 order by nWHTID "
    await this.http.get<any>(this.System.SiteName + "api/PettyCash/GetDB/" + select).toPromise().then(data => {
      this.WithholdingTax = data != null ? data : [];
    });
  }
  //#endregion

  //#region "GetGetBuArea"
  async GetBuArea() {
    await this.http.get(this.System.SiteName + "api/Autocomplete/MT_BUSINESS_AREA/*").toPromise().then((data: Response) => {
      this.arrBuArea = data != null ? data : [];
      let _BU = this.arrBuArea.filter(f => f.CompCode == this.sComCode);
      this.BuArea = _BU[0].BUSINESS_AREA;
      this.PettycashFrom.patchValue({ txtBU: this.BuArea });
    })
  }
  //#endregion

  RawDataIO: any;
  //#region "GetAutocompleteIO"
  async GetAutocompleteIO() {
    //_WithholdingTax
    const httpOptions_IO = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.PettycashFrom.controls['sComCode'].value)
    };
    await this.http.get<any>(this.System.SiteName + "api/_System/GetIO2", httpOptions_IO).toPromise().then(data => {
      this.RawDataIO = data != null ? data : [];
    });
  }
  //#endregion

  //#region "GetAutocompleteVendorNoPE"
  async GetAutocompleteVendorNoPE() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),

      params: new HttpParams()
        .set("sCompCode", this.sComCode + "")
        .set("sReqType", '40'),

    };
    await this.http.get<any>(this.System.SiteName + "api/_System/GetVendor", httpOptions).toPromise().then(data => {
      if (data) {
        this.DataVendor_NoPE = data;
      }

    })
  }
  //#endregion

  //#region "GetAutocompleteVendorNoPE"
  async GetAutocompleteGetVendorOneTime() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),

      params: new HttpParams()
        .set("sComCode", this.sComCode + "")
    };
    await this.http.get<any>(this.System.SiteName + "api/_System/GetVendorOneTimebyComp", httpOptions).toPromise().then(data => {

      if (data) {
        this.Name_DataVendor = data;
      }

    })
  }
  //#endregion


  DataCountry: any;
  //#region "GetAutocompleteCountry"
  async GetAutocompleteCountry() {
    await this.http.get<any>(this.System.SiteName + "api/_System/GetContry").toPromise().then(res => {
      this.DataCountry = res
      let _country = this.DataCountry.filter(f => f.sCountryID == this.nCountryID)
      this.PettycashFrom.patchValue({ sCountryName: _country[0].sCountryName, nCountryID: _country[0].nCountryID })
    })
  }
  //#endregion

  DataProvince: any;
  //#region "GetAutocompleteProvince"
  async GetAutocompleteProvince() {
    await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
      this.DataProvince = res;
    })
  }
  //#endregion

  //#region
  GetLastInvoice() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),

      params: new HttpParams()
        .set("sReqType", '40'),

    };

  }
  //#endregion

  //#region Add GL
  AddGL() {
    this.ArrGL.push(new FormGroup({
      txtGL: new FormControl('', Validators.required),
      txtCostCenter: new FormControl('', Validators.required),
      txtIO: new FormControl('', Validators.required),
      txtAmountExcludedVAT: new FormControl('', Validators.required),
      txtText: new FormControl('', Validators.required),
      IsDelete: new FormControl(false),
    }));
    this.DataIO.push([]);

  }

  indexDel: any;
  DeleteGL(_Index) {

    var _this = this;
    if (this.IsEdit) {
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, function () {
        _this.ArrGL.at(_Index).patchValue({ IsDelete: true });
        _this.indexDel = _Index
        let FieldGLValid: string[] = ['txtGL', 'txtCostCenter', 'txtIO', 'txtAmountExcludedVAT', 'txtText'];
        for (let i = 0; i < FieldGLValid.length; i++) {
          _this.ArrGL.at(_Index).get(FieldGLValid[i]).clearValidators();
          _this.ArrGL.at(_Index).get(FieldGLValid[i]).setValidators([]);
          _this.ArrGL.at(_Index).get(FieldGLValid[i]).updateValueAndValidity();
        }
      }, function () { });
    } else {
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, function () {
        _this.ArrGL.at(_Index).patchValue({ IsDelete: true });
        let FieldGLValid: string[] = ['txtGL', 'txtCostCenter', 'txtIO', 'txtAmountExcludedVAT', 'txtText'];
        for (let i = 0; i < FieldGLValid.length; i++) {
          _this.ArrGL.at(_Index).get(FieldGLValid[i]).clearValidators();
          _this.ArrGL.at(_Index).get(FieldGLValid[i]).setValidators([]);
          _this.ArrGL.at(_Index).get(FieldGLValid[i]).updateValueAndValidity();
        }
      }, function () { });
    }
  }
  //#endregion

  //#endregion

  LoadIO(index: any) {
    try {
      let costcener = this.ArrGL.value[index].txtCostCenter;
      this.DataIO = this.RawDataIO.filter(data => data.RESP_COST_CENTER == costcener)
      if (this.DataIO) {
      } else {
        this.DataIO = ["", ""];
      }
    } catch (e) {
      this.DataIO = ["", ""];
    }
  }

  //All event onclick Draft submit cancel print recall
  async onClick(value: string) {
    var _This = this;
    var FieldValid: string[] = [];
    let chkTotal = true;
    let negativeTotal = false;
    let row = this.rows.filter(f => f.del != true)
    let nGrandTotal = 0;
    if (row.length > 0) {
      let lstTreqiTm = this.lstTreqiTm.filter(f => f.IsDelete != true && f.cVenderMaster == "N");
      let TotalAmountVat = 0;
      let amount = 0;
      for (var i = 0; i < lstTreqiTm.length; i++) {
        TotalAmountVat = TotalAmountVat + this.ConvertCurrentTonumber(lstTreqiTm[i].TotalAmountVat);
        let row = this.rows.filter(f => f.del != true && f.nItem == lstTreqiTm[i].nItem);
        for (var j = 0; j < row.length; j++) {
          amount = this.setfloat((amount + parseFloat(row[j].amount)).toFixed(2));
        }
        var nTotalInvoice = this.System._ParseFloatToZero(TotalAmountVat.toFixed(2));
        var nTotalGL = this.System._ParseFloatToZero(amount.toFixed(2));
        nGrandTotal += this.ConvertCurrentTonumber(lstTreqiTm[i].TotalAmountVat);
        if (nTotalInvoice != nTotalGL) {
          chkTotal = false;
          break;
        }
      }
    }
    if (nGrandTotal < 0) {
      negativeTotal = true;
    }
    if (value == 'Submit') {
      if (this.PettycashFrom.value['_cbChequeType'] == 2) {
        FieldValid = ['ddlBank', 'txtApprove1', 'txtApprove2', 'txtBankBranch', 'txtBankAccountNo', 'txtEmail', 'txtContactName', 'lblBankAccountName'];

      } else {
        FieldValid = ['txtApprove1', 'txtApprove2', 'txtEmail', 'txtContactName'];
      }
      if (this.PettycashFrom.value['chkApprove1'] == true) {
        FieldValid = FieldValid.filter(data => data != 'txtApprove1')
      }
      let bank = this.PettycashFrom.get('ddlBank').value;
      let chkOther = bank.search('Other') != -1 ? true : false;
      if (chkOther) {
        FieldValid.push("Bankother");
      }
    }
    if ((value == 'Draft')) {
      FieldValid = ['txtContactName'];
    }
    let _FormGroup = this.PettycashFrom;
    let IsValid: boolean = true;
    if (ArrFile.filter(f => f.IsDelete === false).length <= 0 && value !== 'Draft') {
      IsValid = false;
      const chkFile =  document.getElementById('dv_dvUploadFile');
      chkFile.style.border = '1px solid red';
    }
    FieldValid.forEach(function (Field) {
      if (!_FormGroup.get(Field).valid && _FormGroup.get(Field).status != "DISABLES") {
        IsValid = false;
        return false;
      }
    });
    let IsDup = await this.CheckDupinvoice();
    switch (value) {
      case "Draft":
        if (IsDup) {
          this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Receipt_Duplicate, undefined);
        } else {
          if (IsValid) {
            if (negativeTotal) {
              _This.System.UnBlockUI()
              _This.SW.SwAlert.Error(_This.SW.BoxMsg.Title_Error, _This.SW.BoxMsg.Desc_Error_Negative_Value, undefined)
            }
            else if (chkTotal) {
              this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.ConfirmSaveDraft, function () {
                _This.SaveDaft()
                _This.System.BlockUI();
              }, function () { _This.System.UnBlockUI() })
            } else {
              _This.System.UnBlockUI()
              _This.SW.SwAlert.Error(_This.SW.BoxMsg.Title_Error, _This.SW.BoxMsg.Desc_Receipt_TotalNoMatch, function () { _This.System.UnBlockUI() })
            }

          } else {
            this.System.UnBlockUI()
            FieldValid.forEach(function (Field) {
              const control = _FormGroup.get(Field);             //{3}
              if (control instanceof FormControl) {             //{4}
                control.markAsTouched({ onlySelf: true });
              }
            });

          }
        }
        break;
      case "Submit":
        if (IsDup) {
          this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Receipt_Duplicate, undefined);
        } else {
          if (IsValid) {
            if (row.length != 0) {
              let ChkData = this.rows.filter(data => data.del != true).length > 0 ? true : false
              if (negativeTotal) {
                _This.System.UnBlockUI()
                _This.SW.SwAlert.Error(_This.SW.BoxMsg.Title_Error, _This.SW.BoxMsg.Desc_Error_Negative_Value, undefined)
              }
              else if (chkTotal && ChkData) {
                this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Submit, function () {
                  _This.SaveSubmit()
                }, function () { _This.System.UnBlockUI() })
              } else {
                _This.System.UnBlockUI()
                _This.SW.SwAlert.Error(_This.SW.BoxMsg.Title_Error, _This.SW.BoxMsg.Desc_Error_Information + " or " + _This.SW.BoxMsg.Desc_Receipt_TotalNoMatch, function () { _This.System.UnBlockUI() })
              }

            } else {
              this.System.UnBlockUI()
              this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Warning_Save, function () { })
              let FieldGLValid: string[] = ["txtGL", "txtCostCenter", "txtIO", "txtAmountExcludedVAT", "txtText"];
              for (let i = 0; i < this.ArrGL.length; i++) {
                FieldGLValid.forEach(function (Field) {
                  let FromArray = _FormGroup.get('ArrGL') as FormArray;
                  const control = FromArray.at(i).get(Field);             //{3}
                  if (control instanceof FormControl) {             //{4}
                    control.markAsTouched({ onlySelf: true });
                  }
                });
              }
            }

          } else {
            FieldValid.forEach(function (Field) {
              const control = _FormGroup.get(Field);
              if (control instanceof FormControl && _FormGroup.get(Field).status != "DISABLES") {
                control.markAsTouched({ onlySelf: true });
              }
            });
          }
        }
        break;
      case "Print":
        this.Export();
        break;
      case "Back":
        this.router.navigate(['/home'])
        break;
      case "Cancel":
        this.System.UnBlockUI();
        if (_This.sComment === null || _This.sComment === "" || _This.sComment === undefined) {
          _This.SW.SwAlert.Error(_This.SW.BoxMsg.Title_Error, _This.SW.BoxMsg.Desc_Specify_Comment, undefined);
        }
        else {
          this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, function () {
            _This.OnCancel()
            _This.System.BlockUI();
          }, function () { _This.System.UnBlockUI() })
        }
        break;
      case "Recall":
        this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, "Recall", function () {
          _This.System.BlockUI();
          _This.OnRecall()
        }, function () { _This.System.UnBlockUI() })
        break;
      default:
    }
    _This.clicked = false;
  }

  async CheckDupinvoice() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    let _ChkInvoice: boolean = true;
    let ChkDup = {
      lstItem: this.lstTreqiTm.filter(f => f.cVenderMaster != "M" && f.IsDelete != true),
      nReqID: this.ReqID
    };
    let DataEdit = JSON.stringify(ChkDup)
    await this.http.post<any>(this.System.SiteName + "api/PettyCash/CheckInvoicecopy", DataEdit, { headers }).toPromise().then(data => {
      _ChkInvoice = data;
    });
    return _ChkInvoice;
  }

  //restatus from submit to draft
  OnRecall() {
    let _This = this
    this.http.get(this.System.SiteName + "api/PettyCash/RecallSubmit/" + this.ReqID + "/" + this.sComment).subscribe((data) => {
      let status = data
      this.System.UnBlockUI();
      if (status[0] == "success") {
        this.SW.SwAlert.Success(this.SW.BoxMsg.Title_Success, "Data is already recalled.", function () {
          _This.router.navigate(['/home'])
        });
      } else {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Error, function () { });
      }
    })
  }

  //set Contact
  onSelectContact(event: TypeaheadMatch): void {

    let txtSearch = event.item['UserID'];
    let lstData = this.DataEmployee.filter(user => user.nUserID == txtSearch)
    if (lstData != "") {
      this.PettycashFrom.patchValue({
        txtEmail: lstData[0].sEmail,
        sRole: lstData[0].nRole,
        txtTel: lstData[0].sTel,
        txtunit: lstData[0].sUnit,
        nContact: txtSearch
      });

    } else {
      this.PettycashFrom.patchValue({
        txtEmail: lstData[0].sEmail,
        sRole: lstData[0].nRole,
        txtTel: lstData[0].sTel,
        txtunit: lstData[0].sUnit,
        nUserIDContact: ""
      });
    }
  }

  onSelectContact2(sName: any) : void {
    let lstData = this.DataEmployee.filter(user => user.sName + " " + user.sSurName == sName)[0]
    if (lstData != "") {
      this.PettycashFrom.patchValue({
        txtEmail: lstData.sEmail,
        txtContactName: sName,
        sRole: lstData.nRole,
        txtTel: lstData.sTel,
        txtunit: lstData.sUnit,
        nContact: lstData.nUserID,
      });

    }
  }
  IsOneTimeVendor: boolean = false;
  //set Employee & Vendor
  getBankBranch(vendorCode, sValue) {
    var bankList = []
    this.masterBankAccountNo.filter(x => x.VENDOR_CODE == vendorCode).forEach((item, i) => {
      bankList.push(item.BANK)
    });
    var bankBranch = this.masterBankBranch.filter(x => bankList.includes(x.BANK_KEY))
    bankBranch.forEach((item, i) => {
      item.sort = bankList.indexOf(item.BANK_KEY)
    });
    bankBranch.sort((a, b) => a.sort - b.sort)
    if (sValue == "Y") {
      bankBranch.push({ fullname: "N/A", BANK_BRANCH: null, BANK_KEY: "N/A", CITY: null, COUNTRY: null, NAME_OF_BANK: "N/A", STREET: null, SWIFT: null })
    }
    return bankBranch;
  }
  async Reject() {
    let _this = this;
    let sComment = _this.sComment;
    if (sComment === null || sComment === "") {
      _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Specify_Comment, undefined)
    }
    else{
      let DataSave = {
        TRequest: {
          sRequestID: _this.PettycashFrom.value['nReqID'],
          sComment: sComment
        },
      }
      let Data = JSON.stringify(DataSave)
      let save = function () {
        _this.System.BlockUI();
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        _this.http.post(_this.System.SiteName + "api/ROService/Reject", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            ArrFile = [];
            _this.System.UnBlockUI();
            _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_SaveComplete, function () { _this.router.navigate(["ro-service"]) });
          } else {
            _this.System.UnBlockUI();
          }
        });
      }
      _this.SW.SwAlert.Confirm(_this.SW.BoxMsg.Title_Confirm, _this.SW.BoxMsg.Desc_Confirm_Submit, save, function () { });
    }
  }
  onSelectedVendor(event: TypeaheadMatch, from: string): void {
    this.VendorCode = event.item['VENDOR_CODE'];
    let txtSearch = event.item['VENDOR_CODE'];
    let txtVendorName = event.item['VENDORNAME']
    let txtsAddress = event.item['ADDRESS']
    let txtTAX_NUMBER = event.item['TAX_ID']
    if (from == 'txtVendorCode') {
      var bankBranch = this.getBankBranch(event.item.VENDOR_CODE, event.item.sValue)
      this.BankBranch = bankBranch;
      if (bankBranch.length > 0) {
        this.PettycashFrom.patchValue({
          txtBankBranch: bankBranch[0].NAME_OF_BANK,
        })
        this.BankCode = bankBranch[0].BANK_KEY;
        var bankAcoount = this.masterBankAccountNo.filter(x => x.VENDOR_CODE == event.item.VENDOR_CODE && x.BANK == bankBranch[0].BANK_KEY)
        if (event.item.sValue == "Y" && bankBranch[0].BANK_KEY) {
          bankAcoount.push({ fullname: "N/A", VENDOR_CODE: null, BANK: null, BANK_ACCOUNT: "N/A", ACCOUNT_HOLDER_NAME: null })
        }
        if (bankAcoount.length > 0) {
          this.BankAccountNo = bankAcoount;
          this.PettycashFrom.patchValue({
            txtBankAccountNo: bankAcoount[0].BANK_ACCOUNT,
          })
        }
        this.PettycashFrom.controls['txtBankBranch'].enable();
        this.PettycashFrom.controls['txtBankAccountNo'].enable();
      }
      else {
        this.PettycashFrom.patchValue({
          txtBankBranch: null,
          txtBankAccountNo: null,
        })
        this.PettycashFrom.controls['txtBankBranch'].enable();
        this.PettycashFrom.controls['txtBankAccountNo'].disable();
      }
      let field = ['txtVendorName', 'txtAddress', 'txtTaxID']
      field.forEach(data => this.PettycashFrom.get(data).disable());
      field.forEach(data => this.PettycashFrom.get(data).markAsUntouched());
      this.PettycashFrom.patchValue({ lblBankAccountName: txtVendorName })
      this.PettycashFrom.patchValue({ txtVendorCode: txtSearch, txtVendorName: txtVendorName.trim(), txtAddress: txtsAddress, txtTaxID: txtTAX_NUMBER })
    } else if (from == 'txtVendorCode_PX') {
      let _company = event.item['sCountryID'] == null ? this.DataCountry.filter(f => f.sCountryID == "213") : this.DataCountry.filter(f => f.sCountryID == event.item['sCountryID'])
      this.sCountry = _company[0].sCountryName;
      if (_company[0].sCountryID != "213") {
        this.DataProvince = [];
      }

      this.nCountryID = _company[0].sCountryID
      this.IsOneTimeVendor = event.item['IsOnetimeVendor'];
      let field = ['txtVendorName_PX', 'txtAddress_PX', 'txtTaxID_PX']
      if (event.item['IsOnetimeVendor']) {
        field.forEach(data => this.PettycashFrom.get(data).enable());
        field.forEach(data => this.PettycashFrom.get(data).setValidators(Validators.required));
        this.PettycashFrom.patchValue({
          sCountryName: this.sCountry
          , sCountryID: this.nCountryID
          , sProvCode: event.item['sProvCode']
          , sProvName: event.item['sProvName']
          , sAmpCode: event.item['sAmpCode']
          , sAmpName: event.item['sAmpName']
          , sTumbonCode: event.item['sTumbonCode']
          , sTumbonName: event.item['sTumbonName']
          , sPostCode: event.item['sPostCode']
          , sFaxNumber: event.item['sFaxNumber']
          , sPhoneNumber: event.item['TEL']
          , sVendorEmail: event.item['sEMAIL']
        })
        txtVendorName = null;
        txtsAddress = null;
        txtTAX_NUMBER = null;
      } else {
        field.forEach(data => this.PettycashFrom.get(data).disable());
        field.forEach(data => this.PettycashFrom.get(data).markAsUntouched());
        this.PettycashFrom.patchValue({
          sCountryName: null
          , sCountryID: null
          , sProvCode: null
          , sProvName: null
          , sAmpCode: null
          , sAmpName: null
          , sTumbonCode: null
          , sTumbonName: null
          , sPostCode: null
          , sFaxNumber: null
          , sPhoneNumber: null
          , sVendorEmail: null
        })
      }
      this.PettycashFrom.patchValue({ txtVendorCode_PX: txtSearch, txtVendorName_PX: txtVendorName, txtAddress_PX: txtsAddress, txtTaxID_PX: txtTAX_NUMBER })
    } else if (from == 'txtVendorName_PX') {
      //this.PettycashFrom.patchValue({ txtVendorName_PX: txtVendorName, txtAddress_PX: txtsAddress, txtTaxID_PX: txtTAX_NUMBER })
      this.PettycashFrom.patchValue({
        txtVendorName_PX: txtVendorName
        , txtAddress_PX: txtsAddress
        , txtTaxID_PX: txtTAX_NUMBER
        , sCountryName: this.sCountry
        , sCountryID: event.item['sCountryID']
        , sProvCode: event.item['sProvCode']
        , sProvName: event.item['sProvName']
        , sAmpCode: event.item['sAmpCode']
        , sAmpName: event.item['sAmpName']
        , sTumbonCode: event.item['sTumbonCode']
        , sTumbonName: event.item['sTumbonName']
        , sPostCode: event.item['sPostCode']
        , sFaxNumber: event.item['sFaxNumber']
        , sPhoneNumber: event.item['TEL']
        , sVendorEmail: event.item['sEMAIL']
      })
    }

  }

  lstitemline: any;
  lstData: any;

  //Copy ReqNo olds then do this will set data to form control and default value by condition
  onSelectCopyReqNo(event: TypeaheadMatch): void {
    let sRequestID = event.item['sRequestID'];
    let arrItemNo = [];
    let arrVenderMaster = [];
    this.rows = [];
    this.lstTreqiTm = [];
    //this.onTReqbyID(sRequestID);
 
    this.http.get<any>(this.System.SiteName + "api/PettyCash/GetTRequestCopy/" + sRequestID + "/" + this.sComCode).toPromise().then((data: Response) => {
      this.lstData = data;
      if (data) {
        this.BankCode = this.lstData[0].BANK_KEY;
        this.VendorCode = this.lstData[0].VENDOR_CODE;
        var bankAcoount = []
        var bankBranch1 = null
        var bankBranch = this.getBankBranch(this.lstData[0].sVendorCode, this.lstData[0].sValue1)
        this.BankBranch = bankBranch;
        if (bankBranch.length > 0) {
          this.BankCode = this.lstData[0].BANK_KEY;
          if (event.item.sValue == "Y" && bankBranch[0].BANK_KEY === "N/A") {
            bankAcoount = [{ fullname: "N/A", VENDOR_CODE: null, BANK: null, BANK_ACCOUNT: "N/A", ACCOUNT_HOLDER_NAME: null }];
          }
          if (bankAcoount.length > 0) {
            this.BankAccountNo = bankAcoount;
          }
          if (this.lstData[0].BANK_NAME === bankBranch[0].NAME_OF_BANK) {
            bankBranch1 = bankBranch[0].NAME_OF_BANK
            bankAcoount = this.masterBankAccountNo.filter(x => x.VENDOR_CODE == this.lstData[0].VENDOR_CODE && x.BANK == bankBranch[0].BANK_KEY)
            this.PettycashFrom.controls['txtBankBranch'].enable();
          }

          this.PettycashFrom.controls['txtBankAccountNo'].enable();
        }

        //SET form control
        this.PettycashFrom.patchValue({
          ddlBank: this.lstData[0].sBankName == null ? "" : this.lstData[0].sBankName,
          Bankother: this.lstData[0].sBankOther == "" ? null : this.lstData[0].sBankOther,
          lblBankAccountName: this.lstData[0].sAccountName,
          txtBankAccountNo: this.lstData[0].sAccountNo,
          txtBankBranch: bankBranch1,
          lblGrandTotalVat: this.lstData[0].nGrandTotalAmtVat == null ? "0.00" : parseFloat(this.lstData[0].nGrandTotalAmtVat).toFixed(2),
          lblGrandTotalExcludedVAT: this.lstData[0].nGrandTotalAmt == null ? "0.00" : parseFloat(this.lstData[0].nGrandTotalAmt).toFixed(2),
          lblGrandTotalIncluded: this.lstData[0].nGrandTotalAmtInvoice == null ? "0.00" : parseFloat(this.lstData[0].nGrandTotalAmtInvoice).toFixed(2),
          lblGrandTotalWHD: this.lstData[0].nGrandTotalAmtInvoice == null ? "0.00" : parseFloat(this.lstData[0].nGrandTotalWithholdingTax).toFixed(2),
          txtApprove2: this.lstData[0].sApprove2,
          chkApprove1: this.lstData[0].cSkipApprove1 == "Y" ? true : false,
          nUserID1: this.lstData[0].nApprove1,
          nUserID2: this.lstData[0].nApprove2,

        })

        if (this.lstData[0].cSkipApprove1 == "Y") {
          this.isSkip = true;
          this.PettycashFrom.patchValue({ txtApprove1: null })
          this.PettycashFrom.get('txtApprove1').disable();
        } else {
          this.PettycashFrom.get('txtApprove1').enable();
          this.PettycashFrom.get('txtApprove1').setValidators(Validators.required);
          this.PettycashFrom.patchValue({ txtApprove1: this.lstData[0].sApprove1 })
        }
        for (var i = 0; i < this.lstData.length; i++) {
          let ItemNo = arrItemNo.includes(this.lstData[i].nItemNo);
          let VenderMaster = arrVenderMaster.includes(this.lstData[i].cVenderMaster);
          if (this.lstData[i].sRequestID1 != null || this.lstData[i].sRequestID2 != null) {
            if (!ItemNo || !VenderMaster) {
              arrItemNo.push(this.lstData[i].nItemNo);
              arrVenderMaster.push(this.lstData[i].cVenderMaster);
              this.sCountry = "ประเทศไทย";
              this.nCountryID = "213";
              let arrsCountry = this.DataCountry.filter(f => f.sCountryID == this.lstData[i].sCountryID)
              if (arrsCountry.length != 0) {
                let sCountry = arrsCountry[0].sCountryName;
                this.sCountry = sCountry;
                this.nCountryID = this.lstData[i].sCountryID;
              }
              this.lstTreqiTm.push({
                vendor: this.lstData[i].sVendorCode1
                , vName: this.lstData[i].sVendorName
                , TaxID: this.lstData[i].sTAXID
                , address: this.lstData[i].sVendorAddress
                , cbOffice: this.lstData[i].nOfficeType
                , BranchCode: this.lstData[i].sVendorBranch
                , dInvoice: this.lstData[i].dInvoiceDate
                , Invoice: this.lstData[i].sInvoiceNo
                , Desc: this.lstData[i].sInvoiceDesc
                , TotalAmountInvoice: this.lstData[i].nIncludeVAT == null ? null : parseFloat(this.lstData[i].nIncludeVAT).toFixed(2)
                , currency: this.lstData[i].sCurrency
                , TotalAmountVat: this.lstData[i].nExcludeVAT == null ? null : parseFloat(this.lstData[i].nExcludeVAT).toFixed(2)
                , VatAmount: this.lstData[i].nVAT == null ? null : parseFloat(this.lstData[i].nVAT).toFixed(2)
                , WithholdingTax: this.lstData[i].nWHTID == null ? null : (this.lstData[i].nWHTID) + ""
                , WithholdingTax2: this.lstData[i].nWHTID2 == null ? null : (this.lstData[i].nWHTID2) + ""
                , WithholdingRate: this.lstData[i].nWHTVal == 0 ? '0.00' : parseFloat(this.lstData[i].nWHTVal).toFixed(2)
                , WithholdingRate2: this.lstData[i].nWHTVal2 == 0 ? '0.00' : parseFloat(this.lstData[i].nWHTVal2).toFixed(2)
                , WithholdingVal: this.lstData[i].nWHTVal == null ? '0.00' : parseFloat(this.lstData[i].nWHTVal).toFixed(2)
                , WithholdingVal2: this.lstData[i].nWHTVal2 == null ? '0.00' : parseFloat(this.lstData[i].nWHTVal2).toFixed(2)
                , WHTOther: this.lstData[i].sWHTCode == null ? null : this.lstData[i].nWHTRate.toFixed(2)
                , WHTOther2: this.lstData[i].sWHTCode2 == null ? null : this.lstData[i].nWHTRate2.toFixed(2)
                , Vattype: this.lstData[i].sVATType
                , nItem: this.lstData[i].nItemNo
                , cVenderMaster: this.lstData[i].cVenderMaster
                , IsDelete: this.lstData[i].IsDelete
                , sCountryID: this.nCountryID
                , sCountryName: this.sCountry
                , sProvCode: this.lstData[i].sProvCode
                , sAmpCode: this.lstData[i].sAmpCode
                , sTumbonCode: this.lstData[i].sTumbonCode
                , sProvName: this.lstData[i].sProvName
                , sAmpName: this.lstData[i].sAmpName
                , sTumbonName: this.lstData[i].sTumbonName
                , sPostCode: this.lstData[i].sPostCode
                , sPhoneNumber: this.lstData[i].sPhoneNumber
                , sFaxNumber: this.lstData[i].sFaxNumber
                , sVendorEmail: this.lstData[i].sEmail1
                , sVendorAddress: this.lstData[i].sAddressOneTime
                , IsOneTimeVendor: this.lstData[i].IsVendorOneTime
                , nInvoiceType: this.lstData[i].nInvoiceType1

              })
              this.nItem = this.lstData[i].nItemNo
            }

          }

          let nChequeType = this.lstData[0].sPaymentType == "C" ? 1 : 2;
          this._cbChequeType(nChequeType);

          if (this.lstData[0].cSkipApprove1 == "Y") {
            this.PettycashFrom.get('txtApprove1').disable()
            this.PettycashFrom.patchValue({ txtApprove1: null });
          }
          this.PettycashFrom.get('txtVendorName').disable();
          this.PettycashFrom.get('txtTaxID').disable();
          this.PettycashFrom.get('txtAddress').disable();

          if (this.lstData[i].sRequestID2 != null) {
            this.rows.push({
              Invoice: this.lstData[i].sInvoiceNo
              , type: this.lstData[i].sVATType
              , GL: this.lstData[i].sGL
              , costcenter: this.lstData[i].sCCTR
              , IO: this.lstData[i].sIO
              , desc: this.lstData[i].sText
              , amount: this.lstData[i].nAmtExcldVAT == null ? null : parseFloat(this.lstData[i].nAmtExcldVAT).toFixed(2)
              , del: this.lstData[i].cActive == "Y" ? false : true
              , nItem: this.lstData[i].nItemNo
              , nLine: this.lstData[i].nLineNo
              , WHDRate: this.lstData[i].nWHTRate == 0 ? null : parseFloat(this.lstData[i].nWHTRate).toFixed(2)
              , WHDtax: this.lstData[i].sWHTCode
              , Time: this.lstData[i].dInvoiceDate
            })

          }
        }

        this.IsNoData = this.rows.filter(data => data.del == false).length == 0 ? true : false;


        this.http.get<any>(this.System.SiteName + "api/PaytoEmployee/GetTRequest/" + sRequestID).toPromise().then((data: Response) => {
          this.lstData = data;
          if (this.lstData) {
            for (var i = 0; i < this.lstData.length; i++) {
              if (this.lstData[i].nItemNo != null) {
                let ItemNo = arrItemNo.includes(this.lstData[i].nItemNo);
                let VenderMaster = arrVenderMaster.includes(this.lstData[i].cVenderMaster);
                if (this.lstData[i].sRequestID1 != null) {
                  if (!ItemNo || !VenderMaster) {
                    this.lstTreqiTm.push({
                      vendor: this.lstData[i].sVendorCode1
                      , vName: this.lstData[i].sVendorName
                      , TaxID: this.lstData[i].sTAXID1
                      , address: this.lstData[i].sVendorAddress
                      , cbOffice: this.lstData[i].nOfficeType
                      , BranchCode: this.lstData[i].sVendorBranch
                      , dInvoice: this.lstData[i].dInvoiceDate
                      , Invoice: this.lstData[i].sInvoiceNo
                      , Desc: this.lstData[i].sInvoiceDesc
                      , TotalAmountInvoice: this.lstData[i].nIncludeVAT == null ? null : parseFloat(this.lstData[i].nIncludeVAT).toFixed(2)
                      , currency: this.lstData[i].sCurrency
                      , TotalAmountVat: this.lstData[i].nExcludeVAT == null ? null : parseFloat(this.lstData[i].nExcludeVAT).toFixed(2)
                      , VatAmount: this.lstData[i].nVAT == null ? null : parseFloat(this.lstData[i].nVAT).toFixed(2)
                      , WithholdingTax: this.lstData[i].nWHTID == null ? null : (this.lstData[i].nWHTID) + ""
                      , WithholdingTax2: this.lstData[i].nWHTID2 == null ? null : (this.lstData[i].nWHTID2) + ""
                      , WithholdingRate: this.lstData[i].nWHTVal == null ? '0.00' : parseFloat(this.lstData[i].nWHTRate).toFixed(2)
                      , WithholdingRate2: this.lstData[i].nWHTVal2 == null ? '0.00' : parseFloat(this.lstData[i].nWHTRate2).toFixed(2)
                      , WithholdingVal: this.lstData[i].nWHTVal == null ? '0.00' : parseFloat(this.lstData[i].nWHTVal).toFixed(2)
                      , WithholdingVal2: this.lstData[i].nWHTVal2 == null ? '0.00' : parseFloat(this.lstData[i].nWHTVal2).toFixed(2)
                      , nWHTBase: this.lstData[i].nWHTBase == null ? '0.00' : parseFloat(this.lstData[i].nWHTBase).toFixed(2)
                      , nWHTBase2: this.lstData[i].nWHTBase2 == null ? '0.00' : parseFloat(this.lstData[i].nWHTBase2).toFixed(2)
                      , WHTOther: this.lstData[i].sWHTCode == null ? null : this.lstData[i].nWHTRate.toFixed(2)
                      , WHTOther2: this.lstData[i].sWHTCode2 == null ? null : this.lstData[i].nWHTRate2.toFixed(2)
                      , Vattype: this.lstData[i].sVATType
                      , nItem: this.lstData[i].nItemNo
                      , cVenderMaster: this.lstData[i].cVenderMaster
                      , IsDelete: this.lstData[i].IsDelete
                      , sCountryID: this.nCountryID
                      , sCountryName: this.sCountry
                      , sProvCode: this.lstData[i].sProvCode
                      , sAmpCode: this.lstData[i].sAmpCode
                      , sTumbonCode: this.lstData[i].sTumbonCode
                      , sProvName: this.lstData[i].sProvName
                      , sAmpName: this.lstData[i].sAmpName
                      , sTumbonName: this.lstData[i].sTumbonName
                      , sPostCode: this.lstData[i].sPostCode
                      , sPhoneNumber: this.lstData[i].sPhoneNumber
                      , sFaxNumber: this.lstData[i].sFaxNumber
                      , sVendorEmail: this.lstData[i].sEmail1
                      , sVendorAddress: this.lstData[i].sAddressOneTime
                      , IsOneTimeVendor: this.lstData[i].IsVendorOneTime
                      , nInvoiceType: this.lstData[i].nInvoiceType1

                    })
                  }
                }
                let _lstTreqIm = this.lstTreqiTm.filter(f => f.cVenderMaster == "M")
                if (_lstTreqIm.length != 0) {
                  this.PettycashFrom.patchValue({
                    txtVendorCode: _lstTreqIm[0].vendor,
                    txtVendorName: _lstTreqIm[0].vName,
                    txtTaxID: _lstTreqIm[0].TaxID,
                    cbOffice: _lstTreqIm[0].cbOffice,
                    txtBranchCode: _lstTreqIm[0].BranchCode,
                    txtAddress: _lstTreqIm[0].address,
                  })
                }
                this.PettycashFrom.get('txtVendorName').disable();
                this.PettycashFrom.get('txtTaxID').disable();
                this.PettycashFrom.get('txtAddress').disable();
              }
            }
          }
        })

      }

    })
  }

  CommentChange(event) {
    this.sComment = event.target.value == null ? "" : event.target.value;
  }
  CommentChangeSSC(event) {
    this.sCommentSSC = event.target.value == null ? "" : event.target.value;
  }

  nUrgentDate: number = 0;
  Istransfer: boolean = false;
  DueDate: Date;
  isSkipA1: boolean = false;

  Dis_calendar: boolean;
  ReqID: any = null;
  //Set Data for Edit or Draft mode
  //Edit Mode then do this will set data to form control and default value by condition
  onTReqbyID(index: String) {
    const requestId = encodeURIComponent(String(index));
    this.System.BlockUI();
    this.ReqID = index;
    //Treq
    this.ArrTransactionHistory = [];
    this.IsNoDataTrans = true;
    this.http.get<any>(this.System.SiteName + "api/_Paytovendor/GetTransactionHistory/" + requestId).toPromise().then((data: Response) => {
      this.ArrTransactionHistory = data;
      if (this.ArrTransactionHistory.length > 0){
        this.IsNoDataTrans = false;
      }
    })
    this.http.get<any>(this.System.SiteName + "api/PettyCash/GetTRequest/" + requestId).toPromise().then((data: Response) => {
      this.lstData = data;
      if (this.lstData) {
        let arrItemNo = [];
        let arrVenderMaster = [];
        this.rows = [];
        this.sReqCode = this.lstData[0].sRequestCode;
        this.BankCode = this.lstData[0].BANK_KEY;
        this.IssReqCode = this.sReqCode == null ? false : true;
        this.sComment = this.lstData[0].sComment;
        this.sCommentSSC = this.lstData[0].sCommentSSC;
        //SET form control
        this.PettycashFrom.patchValue({
          nReqID: index,
          sRole: this.lstData[0].sVendorCode1,
          dDue: new Date(this.lstData[0].dDueDate),
          sComCode: this.lstData[0].sCompCode,
          nUserIDContact: this.lstData[0].nContactID,
          sComName: this.lstData[0].COMPANY_NAME,
          txtContactName: this.lstData[0].sContactName,
          txtDate: this.lstData[0].dRequestDate == null ? new Date() : new Date(this.lstData[0].dRequestDate),
          txtunit: this.lstData[0].sUnitName,
          txtEmail: this.lstData[0].sEmail,
          ddlTypeofPay: this.lstData[0].nReqType,
          txtCopyofRequestNo: this.lstData[0].CopyCode,
          txtTel: this.lstData[0].sTel,
          _cbChequeType: this.lstData[0].sPaymentType == "C" ? 1 : 2,
          ddlBank: this.lstData[0].sBankName == null ? "" : this.lstData[0].sBankName,
          Bankother: this.lstData[0].sBankOther == "" ? null : this.lstData[0].sBankOther,
          lblBankAccountName: this.lstData[0].sAccountName,
          txtBankAccountNo: this.lstData[0].sAccountNo == null && this.lstData[0].sValue == "Y" ? "N/A" : this.lstData[0].sAccountNo,
          nStatus: this.lstData[0].nStatusID,
          lblGrandTotalVat: this.lstData[0].nGrandTotalAmtVat == null ? "0.00" : parseFloat(this.lstData[0].nGrandTotalAmtVat).toFixed(2),
          lblGrandTotalExcludedVAT: this.lstData[0].nGrandTotalAmt == null ? "0.00" : parseFloat(this.lstData[0].nGrandTotalAmt).toFixed(2),
          lblGrandTotalIncluded: this.lstData[0].nGrandTotalAmtInvoice == null ? "0.00" : parseFloat(this.lstData[0].nGrandTotalAmtInvoice).toFixed(2),
          lblGrandTotalWHD: this.lstData[0].nGrandTotalAmtInvoice == null ? "0.00" : parseFloat(this.lstData[0].nGrandTotalWithholdingTax).toFixed(2),
          txtApprove2: this.lstData[0].sApprove2,
          chkApprove1: this.lstData[0].cSkipApprove1 == "Y" ? true : false,
          nUserID1: this.lstData[0].nApprove1,
          nUserID2: this.lstData[0].nApprove2,
          sComment: this.lstData[0].sComment,
          sCommentSSC: this.lstData[0].sCommentSSC,

        })
        if (this.lstData[0].IsRoService) this.urgentDay = 8;

        var bankBranch = this.getBankBranch(this.lstData[0].sVendorCode, this.lstData[0].sValue1)
        if (this.lstData[0].BANK_NAME == null && this.lstData[0].sValue1 == "Y") {
          this.PettycashFrom.patchValue({
            txtBankBranch: "N/A",
          })
          this.PettycashFrom.controls['txtBankBranch'].enable();
        }
        else if (bankBranch.length > 0) {
          this.PettycashFrom.patchValue({
            txtBankBranch: this.lstData[0].BANK_NAME == null && this.lstData[0].sValue1 == "Y" ? "N/A" : this.lstData[0].BANK_NAME,
          })
          this.PettycashFrom.controls['txtBankBranch'].enable();
        }
        this.PettycashFrom.controls['txtBankAccountNo'].enable();

        if (this.lstData[0].cSkipApprove1 == "Y") {
          this.isSkip = true;
          this.PettycashFrom.patchValue({ txtApprove1: null })
          this.PettycashFrom.get('txtApprove1').disable();
        } else {
          this.PettycashFrom.get('txtApprove1').enable();
          this.PettycashFrom.patchValue({ txtApprove1: this.lstData[0].sApprove1 })
        }
        this.ApproveName1 = this.lstData[0].sApprove1
        this.ApproveName2 = this.lstData[0].sApprove2
        this.ApproveCode1 = this.lstData[0].nApprove1
        this.ApproveCode2 = this.lstData[0].nApprove2
        this.Istransfer = true


        //SET TreqITEM && TreqnLine
        for (var i = 0; i < this.lstData.length; i++) {
          if (this.lstData[i].nItemNo != null) {
            let ItemNo = arrItemNo.includes(this.lstData[i].nItemNo);
            let VenderMaster = arrVenderMaster.includes(this.lstData[i].cVenderMaster);
            if (this.lstData[i].sRequestID != null) {
              if (!ItemNo || !VenderMaster) {
                arrItemNo.push(this.lstData[i].nItemNo);
                arrVenderMaster.push(this.lstData[i].cVenderMaster);
                this.sCountry = "ประเทศไทย";
                this.nCountryID = "213";
                let arrsCountry = this.DataCountry.filter(f => f.sCountryID == this.lstData[i].sCountryID)
                if (arrsCountry.length != 0) {
                  let sCountry = arrsCountry[0].sCountryName;
                  this.sCountry = sCountry;
                  this.nCountryID = this.lstData[i].sCountryID;
                }
                this.lstTreqiTm.push({
                  vendor: this.lstData[i].sVendorCode2
                  , vName: this.lstData[i].sVendorName
                  , TaxID: this.lstData[i].sTAXID2
                  , address: this.lstData[i].sVendorAddress
                  , cbOffice: this.lstData[i].nOfficeType
                  , BranchCode: this.lstData[i].sVendorBranch
                  , dInvoice: this.lstData[i].dInvoiceDate
                  , Invoice: this.lstData[i].sInvoiceNo
                  , Desc: this.lstData[i].sInvoiceDesc
                  , TotalAmountInvoice: this.lstData[i].nIncludeVAT == null ? null : parseFloat(this.lstData[i].nIncludeVAT).toFixed(2)
                  , currency: this.lstData[i].sCurrency
                  , TotalAmountVat: this.lstData[i].nExcludeVAT == null ? null : parseFloat(this.lstData[i].nExcludeVAT).toFixed(2)
                  , VatAmount: this.lstData[i].nVAT == null ? null : parseFloat(this.lstData[i].nVAT).toFixed(2)
                  , WithholdingTax: this.lstData[i].sWHTCode == null ? null : this.lstData[i].sWHTCode
                  , WithholdingTax2: this.lstData[i].sWHTCode2 == null ? null : this.lstData[i].sWHTCode2
                  , WithholdingRate: this.lstData[i].nWHTVal == null ? '0.00' : parseFloat(this.lstData[i].nWHTRate).toFixed(2)
                  , WithholdingRate2: this.lstData[i].nWHTVal2 == null ? '0.00' : parseFloat(this.lstData[i].nWHTRate2).toFixed(2)
                  , WithholdingVal: this.lstData[i].nWHTVal == null ? '0.00' : parseFloat(this.lstData[i].nWHTVal).toFixed(2)
                  , WithholdingVal2: this.lstData[i].nWHTVal2 == null ? '0.00' : parseFloat(this.lstData[i].nWHTVal2).toFixed(2)
                  , nWHTBase: this.lstData[i].nWHTBase == null ? '0.00' : parseFloat(this.lstData[i].nWHTBase).toFixed(2)
                  , nWHTBase2: this.lstData[i].nWHTBase2 == null ? '0.00' : parseFloat(this.lstData[i].nWHTBase2).toFixed(2)
                  , WHTOther: this.lstData[i].sWHTCode == null ? null : this.lstData[i].nWHTRate.toFixed(2)
                  , WHTOther2: this.lstData[i].sWHTCode2 == null ? null : this.lstData[i].nWHTRate2.toFixed(2)
                  , Vattype: this.lstData[i].sVATType
                  , nItem: this.lstData[i].nItemNo
                  , cVenderMaster: this.lstData[i].cVenderMaster
                  , IsDelete: this.lstData[i].IsDelete
                  , sCountryID: this.nCountryID
                  , sCountryName: this.sCountry
                  , sProvCode: this.lstData[i].sProvCode
                  , sAmpCode: this.lstData[i].sAmpCode
                  , sTumbonCode: this.lstData[i].sTumbonCode
                  , sProvName: this.lstData[i].sProvName
                  , sAmpName: this.lstData[i].sAmpName
                  , sTumbonName: this.lstData[i].sTumbonName
                  , sPostCode: this.lstData[i].sPostCode
                  , sPhoneNumber: this.lstData[i].sPhoneNumber
                  , sFaxNumber: this.lstData[i].sFaxNumber
                  , sVendorEmail: this.lstData[i].sEmail1
                  , sVendorAddress: this.lstData[i].sAddressOneTime
                  , IsOneTimeVendor: this.lstData[i].IsVendorOneTime
                  , nInvoiceType: this.lstData[i].nInvoiceType2

                })
                this.nItem = this.lstData[i].nItemNo
              }

            }

            //if (this.lstTreqiTm[i].cVenderMaster == "M") {
            let _lstTreqIm = this.lstTreqiTm.filter(f => f.cVenderMaster == "M")
            if (_lstTreqIm.length != 0) {
              this.PettycashFrom.patchValue({
                txtVendorCode: _lstTreqIm[0].vendor,
                txtVendorName: _lstTreqIm[0].vName,
                txtTaxID: _lstTreqIm[0].TaxID,
                cbOffice: _lstTreqIm[0].cbOffice,
                txtBranchCode: _lstTreqIm[0].BranchCode,
                txtAddress: _lstTreqIm[0].address,
              })
            }
            //}
            this.PettycashFrom.get('txtVendorName').disable();
            this.PettycashFrom.get('txtTaxID').disable();
            this.PettycashFrom.get('txtAddress').disable();

            if (this.lstData[i].sRequestID3 != null && this.lstData[i].sGL != null) {
              this.rows.push({
                Invoice: this.lstData[i].sInvoiceNo
                , type: this.lstData[i].sVATType
                , GL: this.lstData[i].sGL
                , costcenter: this.lstData[i].sCCTR
                , IO: this.lstData[i].sIO
                , desc: this.lstData[i].sText
                , amount: this.lstData[i].nAmtExcldVAT == null ? null : parseFloat(this.lstData[i].nAmtExcldVAT).toFixed(2)
                , del: this.lstData[i].cActive == "Y" ? false : true
                , nItem: this.lstData[i].nItemNo
                , nLine: this.lstData[i].nLineNo
                , WHDRate: this.lstData[i].nWHTRate == 0 ? null : parseFloat(this.lstData[i].nWHTRate).toFixed(2)
                , WHDtax: this.lstData[i].sWHTCode
                , Time: this.lstData[i].dInvoiceDate
              })

            }
          }
        }
        let nitem: any[]
        if (this.lstTreqiTm.length != 0) {
          nitem = this.lstTreqiTm.map(f => this.System.ParseIntToZero(f.nItem))
          this.nItem = Math.max(...nitem)
        } else {
          this.nItem = 0;
        }
        this.IsNoData = this.rows.filter(data => data.del == false).length == 0 ? true : false;
        // if (this.IsNoData) {
        //   this.PettycashFrom.get('ddlUOM').enable();
        // } else {
        //   this.PettycashFrom.get('ddlUOM').disable();
        // }
        this.PettycashFrom.get('ddlUOM').enable();
        let nChequeType = this.lstData[0].sPaymentType == "C" ? 1 : 2;
        this._cbChequeType(nChequeType);
        this.checkOffice();
        if (this.lstData[0].sPaymentType != "C") {
          this.selectBank();
        }

        let nStatus = this.lstData[0].nStatusID
        let DueDate = new Date(this.lstData[0].dDueDate);
        let dRequestDate = new Date(this.lstData[0].dRequestDate);
        this.BankCode = this.lstData[0].sBankKey
        this.IsNew = false
        this.nUrgentDate = this.lstData[0].nReqUrgentDay;
        if (this.ResultPermission) {
          if (nStatus != 2) {
            this.nStatus = nStatus;
            this.fieldsetDisabled = false;
            this.isPrint = true
            this.isSubmit = true
            this.isDraf = true
            this.isCencal = true
            this.isRecall = false
            //this.Todate = this.lstData[0].dRequestDate == null ? this.BusinessDay.SetToday(this.holidays) : new Date(this.lstData[0].dRequestDate);
            this.Todate = this.BusinessDay.SetToday(this.holidays);
            if (DueDate < this.Todate) {
              this.minDate = this.BusinessDay.SetToday(this.holidays);
              this.minDate.setDate(this.minDate.getDate() + 1);
              this.minDate = this.BusinessDay.SetNextDate(this.minDate, this.holidays)
              this.PettycashFrom.patchValue({ dDue: this.minDate });
              if (nStatus == 1 || nStatus == 3 || nStatus == 5 || nStatus == 7 || nStatus == 10) {
                this.olddate = "Old Due Date " + this.System._ParseDateToFormat(new Date(this.lstData[0].dDueDate), "yyyy-MM-dd");
                this.nUrgentDate = 1;
                this.IsReqUrgent = 1;
              }
            } else {
              let nDate = this.BusinessDay.setDueDatebyDate(this.Todate, DueDate, this.holidays);
              let today = this.Todate
              this.minDate = today;
              this.minDate.setDate(this.minDate.getDate() + 1);
              this.minDate = this.BusinessDay.SetNextDate(this.minDate, this.holidays)
              if (nDate < this.urgentDay) {
                this.nUrgentDate = nDate;
                this.IsReqUrgent = 1
              } else {
                this.IsReqUrgent = 0
              }
            }
          } else if (nStatus == 2) {
            this.PettycashFrom.disable();
            this.nStatus = nStatus;
            this.fieldsetDisabled = true;
            this.isRecall = false
            this.isCencal = false
            this.isPrint = true
            this.isDraf = false
            this.isSubmit = false
            let nDate = this.lstData[0].nReqUrgentDay;
            if (nDate < this.urgentDay) {
              this.Todate = null
              this.holidays = [];
              this.nUrgentDate = nDate;
              this.IsReqUrgent = 1

            } else {
              this.IsReqUrgent = 0
            }
            if (this.ResultPermission) {
              this.IsView = true;
            }
            //this.SetLoadform();
          }

        }
        this.Todate = this.BusinessDay.SetToday(this.holidays);
        this.System.UnBlockUI();
      }


    })
    //File
    this.http.get<any>(this.System.SiteName + "api/PettyCash/GetFle/" + encodeURIComponent(String(index))).subscribe(res => {
      let data = res;
      if (data) {
        let arrdata: any[] = [];
        data.forEach(f => arrdata.push({
          nID: f.nFileOrder,
          sPath: f.sPathFile,
          sSystemFileName: f.sSystemFileName,
          sFileName: f.sFileName,
          sSize: parseInt(f.sFileSize)
        }))
        SetData("dvUploadFile", arrdata)
      }

    });
  }

  //default Button
  isRecall: boolean = false;
  isPrint: boolean = false;
  isSubmit: boolean = true;
  isCencal: boolean = false;
  isDraf: boolean = true;

  //convert number to currency
  formatnumber(Digit: number, Grouping: boolean, Data: number): string {
    if (isNaN(Data)) {
      return null;
    } else {
      var item = parseFloat(String(Data).replace(this.currencyChars, ''));
      return new Intl.NumberFormat('en', { maximumFractionDigits: Digit, minimumFractionDigits: Digit, useGrouping: Grouping }).format(item);
    }
  }
  //convert currency to number
  ConvertCurrentTonumber(Data: string): number {
    if (isNullOrUndefined(Data)) {
      return;
    } else {
      let num = Data.replace(this.currencyChars, '');
      return parseFloat(num)
    }
  }

  //calculate when manual key Vat
  txtVat: any;
  ChangeVat() {
    let nVat = this.ConvertCurrentTonumber(this.PettycashFrom.value['txtVatAmount'])
    let Vat = this.formatnumber(2, true, nVat);
    let Total = this.ConvertCurrentTonumber(this.PettycashFrom.value['txtTotalAmountVat'])
    let include = this.formatnumber(2, true, Total + nVat);
    this.PettycashFrom.patchValue({ txtVatAmount: Vat, txtTotalAmountInvoice: include })
  }

  checkOffice() {
    let value = this.PettycashFrom.value['cbOffice'];
    let value_PX = this.PettycashFrom.value['cbOffice_PX'];

    if (value == 2) {
      var code = this.PettycashFrom.get('txtBranchCode').value;
      if (code === '') code = '00000'
      this.PettycashFrom.get('txtBranchCode').enable();
      this.PettycashFrom.patchValue({ txtBranchCode: code });
    } else {
      this.PettycashFrom.get('txtBranchCode').disable();
      this.PettycashFrom.patchValue({ txtBranchCode: "" });

    }
  }

  checkOffice_PX() {
    let value = this.PettycashFrom.value['cbOffice'];
    let value_PX = this.PettycashFrom.value['cbOffice_PX'];
    if (value_PX == 2) {
      var code = this.PettycashFrom.get('txtBranchCode_PX').value;
      if (code === '') code = '00000'
      this.PettycashFrom.get('txtBranchCode_PX').enable();
      this.PettycashFrom.patchValue({ txtBranchCode_PX: code });
    } else {
      this.PettycashFrom.get('txtBranchCode_PX').disable();
      this.PettycashFrom.patchValue({ txtBranchCode_PX: "" });

    }

  }

  cbVATorWHT() {
    let value = this.PettycashFrom.value['cbVat']
    this.IsOneTimeVendor = false;
    if (value == 1) {
      this.PettycashFrom.get('txtVendorCode_PX').markAsUntouched();
      this.PettycashFrom.get('ddlVatType').enable();
      this.PettycashFrom.get('txtVatAmount').enable();
      this.IsSetNoChangecbVat = false;
      let field = ['ddlVatType', 'txtVatAmount']
      field.forEach(data => this.PettycashFrom.get(data).setValidators(Validators.required));
      field.forEach(data => this.PettycashFrom.get(data).updateValueAndValidity());
      this.PettycashFrom.get('ddlWithholdingTax').enable()
      this.PettycashFrom.get('ddlWithholdingTax2').enable()
      this.PettycashFrom.get('nWHTBase').enable()
      this.PettycashFrom.get('nWHTBase2').enable()
      this.PettycashFrom.get('txtWHTAmount').enable()
      this.PettycashFrom.get('txtWHTAmount2').enable()
      if (this.IsEdit) {

      } else {
        this.PettycashFrom.patchValue({ ddlVatType: '' })
      }

    } else {

      var field = ["ddlVatType", "txtWHTOther", "txtWHTOther2", "txtVatAmount"];
      if (!this.IsSetNoChangecbVat) {
        this.IsSetNoChangecbVat = false;
      }
      this.PettycashFrom.patchValue({ ddlVatType: 'VZ', txtWHTOther: null, txtWHTOther2: null, ddlWithholdingTax: "", ddlWithholdingTax2: "" })

      field.forEach(f => this.PettycashFrom.get(f).disable());
      field.forEach(f => this.PettycashFrom.get(f).clearValidators());
      field.forEach(f => this.PettycashFrom.get(f).markAsUntouched());
      this.CalTotalAmount(false)
      this.PettycashFrom.get('ddlWithholdingTax').disable();
      this.PettycashFrom.get('ddlWithholdingTax2').disable();
      this.PettycashFrom.get('nWHTBase').disable();
      this.PettycashFrom.get('nWHTBase2').disable();
      this.PettycashFrom.get('txtWHTAmount').disable();
      this.PettycashFrom.get('txtWHTAmount2').disable();

    }
    if (this.IsEdit) {

    } else {
      this.PettycashFrom.patchValue({ txtVendorCode_PX: null, txtVendorName_PX: null, txtTaxID_PX: null, cbOffice_PX: 1, txtAddress_PX: null });
    }

  }

  numberOnly(event): boolean {
    const charCode = event.key;
    var regExp = new RegExp('[A-Za-z]', 'g');
    if (regExp.test(charCode)) {
      return false;
    } else {
      return true;
    }
  }

  nvat: any;
  CalTotalAmount(byTotal) {
    let TotalAmount = this.ConvertCurrentTonumber(this.PettycashFrom.get('txtTotalAmountVat').value);
    if (!isNullOrUndefined(TotalAmount)) {
      let VatType = this.PettycashFrom.get('ddlVatType').value;
      let Taxvat = this.DataVat.filter(data => data.TAX_CODE == VatType);
      this.nvat = Taxvat.map(re => re.nVAT);
      let vat: any;
      if (VatType != "" && !isNaN(TotalAmount)) {
        let total = "";
        if (VatType == "VZ") {//VZ ไม่คำนวน vat
          vat = "";
          this.PettycashFrom.patchValue({ txtVatAmount: null })
          this.PettycashFrom.get('txtVatAmount').disable()
          this.PettycashFrom.get('txtVatAmount').reset()
          total = isNaN(TotalAmount) ? "" : this.formatnumber(2, true, TotalAmount);
        } else if (isNaN(TotalAmount)) {
          this.PettycashFrom.patchValue({ txtTotalAmountInvoice: null, txtVatAmount: null })
        }
        else {
          let _Vat = TotalAmount * parseFloat(this.nvat[0])
          vat = isNaN(TotalAmount) ? "" : this.formatnumber(2, true, (TotalAmount * parseFloat(this.nvat[0])));
          total = isNaN(TotalAmount) ? "" : this.formatnumber(2, true, (TotalAmount + _Vat));
          this.PettycashFrom.get('txtVatAmount').enable()
        }
        this.PettycashFrom.patchValue({ txtTotalAmountInvoice: total, txtVatAmount: vat })
      } else if (VatType == "VZ") {
        this.PettycashFrom.patchValue({ txtVatAmount: null })
        this.PettycashFrom.get('txtVatAmount').disable()
      } else {
        this.PettycashFrom.patchValue({ txtTotalAmountInvoice: null, txtVatAmount: null })
        this.PettycashFrom.get('txtVatAmount').enable()
      }
    } else {

      let vatOrNovat = this.PettycashFrom.get('cbVat').value
      if (vatOrNovat == 1) {
        if (this.PettycashFrom.get('ddlVatType').value == "VZ") {
          this.PettycashFrom.get('txtVatAmount').disable()
        } else {
          this.PettycashFrom.get('txtVatAmount').enable()
        }

      } else {
        this.PettycashFrom.get('txtVatAmount').disable()
      }

    }
    this.onSetWHTValue(1, byTotal);
    this.onSetWHTValue(2, byTotal);
  }

  ChangeTotal() {
    let TotalAmount = this.ConvertCurrentTonumber(this.PettycashFrom.value['txtTotalAmountVat']);
    this.PettycashFrom.patchValue({ txtTotalAmountVat: this.formatnumber(2, true, TotalAmount) })
  }

  onSelectArrGL(index: any): void {
    let GL = this.ArrGL.value[index].txtGL
    let costcener = this.ArrGL.value[index].txtCostCenter
    this.LoadIO(index);
  }
  //convert to float
  setfloat(index) {
    return parseFloat((Math.round(this.System._ParseFloatToZero(this.ConvertCurrentTonumber(index)) * 100) / 100).toFixed(2));
  }

  nItem = 0;
  Invoice: any[] = [];
  InvoiceDate: any[] = [];
  oldInvoice: any;
  dInvoice: any;
  lstTReq: any[] = [];
  lstTreqiTm: any[] = [];
  chkInvoice: boolean;
  currency: string = 'THB';

  headers = ["Invoice", "type", "GL", "costcenter", "IO", "amount", "desc", "Time"];
  rows: any[] = [];
  // new invoice
  //event after AddInvoice if condition pass will do evnt next step
  createtable() {

    let TotalAmount = this.setfloat(this.PettycashFrom.get('txtTotalAmountVat').value);
    let totalGL = 0;
    let WHDVal = 0;
    let WHDVal2 = 0;
    //check total of TreqTtme with TreqLine
    for (var i = 0; i < this.ArrGL.length; i++) {
      if (this.PettycashFrom.get('ddlWithholdingTax').value == "99" || this.PettycashFrom.get('ddlWithholdingTax').value == "6") {
        this.RateWHT = this.PettycashFrom.value['txtWHTOther'] == null ? null : parseFloat(this.PettycashFrom.value['txtWHTOther'])
      } else {
        let WHTType = this.PettycashFrom.value['ddlWithholdingTax']
        let WTx = this.WithholdingTax.filter(data => data.nWHTID == WHTType)
        this.RateWHT = WTx.length == 0 ? null : WTx[0].nRate;
      }
      if (this.PettycashFrom.get('ddlWithholdingTax2').value == "99" || this.PettycashFrom.get('ddlWithholdingTax2').value == "6") {
        this.RateWHT2 = this.PettycashFrom.value['txtWHTOther2'] == null ? null : parseFloat(this.PettycashFrom.value['txtWHTOther2'])
      } else {
        let WHTType2 = this.PettycashFrom.value['ddlWithholdingTax2']
        let WTx2 = this.WithholdingTax.filter(data => data.nWHTID == WHTType2)
        this.RateWHT2 = WTx2.length == 0 ? null : WTx2[0].nRate;
      }
      let Isdelete = this.ArrGL.value[i].IsDelete
      if (!Isdelete) {
        let AmountExcludedVAT = this.setfloat(this.ArrGL.value[i].txtAmountExcludedVAT);
        totalGL = this.setfloat((totalGL + AmountExcludedVAT).toFixed(2));
      }
    }
    let txtWHTAmount = this.setfloat(this.PettycashFrom.value['txtWHTAmount']);
    let txtWHTAmount2 = this.setfloat(this.PettycashFrom.value['txtWHTAmount2']);

    WHDVal = txtWHTAmount + 0.00;
    WHDVal2 = txtWHTAmount2 + 0.00;
    let O_date = new Date(this.PettycashFrom.value['txtInvoiceDate']).setHours(0, 0, 0, 0)
    let chk = TotalAmount == totalGL ? true : false;
    //Master
    let chkEmployee = this.lstTreqiTm.filter(f => f.cVenderMaster == 'M')
    if (chk) {
      //if Treq have master is update data but Treq didn't have master will create TreqItem master.
      if (chkEmployee.length == 0) {
        //add or update data to TreqItem
        this.lstTreqiTm.push({
          vendor: this.PettycashFrom.get('txtVendorCode').value
          , vName: this.PettycashFrom.get('txtVendorName').value
          , TaxID: this.PettycashFrom.get('txtTaxID').value
          , address: this.PettycashFrom.get('txtAddress').value
          , cbOffice: this.PettycashFrom.get('cbOffice').value
          , BranchCode: this.PettycashFrom.get('txtBranchCode').value
          , Vattype: this.PettycashFrom.get('ddlVatType').value
          , nItem: ++this.nItem
          , currency: this.PettycashFrom.get('ddlUOM').value
          , cVenderMaster: "M"
          //, dInvoice: new Date(O_date)
          //, Invoice: this.PettycashFrom.get('txtInvoice').value
          //, nInvoiceType: this.PettycashFrom.get('cbVat').value
          , IsDelete: false
          //, TotalAmountInvoice: this.ConvertCurrentTonumber(this.PettycashFrom.get('txtTotalAmountInvoice').value).toFixed(2)
          //, TotalAmountVat: this.ConvertCurrentTonumber(this.PettycashFrom.get('txtTotalAmountVat').value).toFixed(2)
          //, VatAmount: this.PettycashFrom.get('txtVatAmount').value == "" ? null : (this.ConvertCurrentTonumber(this.PettycashFrom.get('txtVatAmount').value)).toFixed(2)
          //, WithholdingRate: this.RateWHT == null ? '0.00' : this.RateWHT.toFixed(2)
          //, WithholdingVal: null
          //, WithholdingTax: null
          //, WHTOther: this.PettycashFrom.get('txtWHTOther').value
        })
      } else {
        // cVenderMaster(M) is only one .
        let lst = this.lstTreqiTm.filter(f => f.cVenderMaster == "N" && f.IsDelete == false)
        if (lst.length == 0) {
          chkEmployee[0].vendor = this.PettycashFrom.get('txtVendorCode').value
          chkEmployee[0].vName = this.PettycashFrom.get('txtVendorName').value
          chkEmployee[0].TaxID = this.PettycashFrom.get('txtTaxID').value
          chkEmployee[0].address = this.PettycashFrom.get('txtAddress').value
          chkEmployee[0].cbOffice = this.PettycashFrom.get('cbOffice').value
          chkEmployee[0].BranchCode = this.PettycashFrom.get('txtBranchCode').value
          chkEmployee[0].currency = this.PettycashFrom.get('ddlUOM').value
          chkEmployee[0].cVenderMaster = "M"
          //chkEmployee[0].dInvoice = new Date(O_date)
          //chkEmployee[0].Invoice = this.PettycashFrom.get('txtInvoice').value
          //chkEmployee[0].Vattype = this.PettycashFrom.get('ddlVatType').value
          //chkEmployee[0].nInvoiceType = this.PettycashFrom.get('cbVat').value
          chkEmployee[0].IsDelete = false
          //chkEmployee[0].TotalAmountInvoice = this.ConvertCurrentTonumber(this.PettycashFrom.get('txtTotalAmountInvoice').value).toFixed(2)
          //chkEmployee[0].TotalAmountVat = this.ConvertCurrentTonumber(this.PettycashFrom.get('txtTotalAmountVat').value).toFixed(2)
          //chkEmployee[0].VatAmount = this.PettycashFrom.get('txtVatAmount').value == "" ? null : this.ConvertCurrentTonumber(this.PettycashFrom.get('txtVatAmount').value).toFixed(2)
          //chkEmployee[0].WithholdingRate = this.RateWHT == null ? '0.00' : this.RateWHT.toFixed(2)
          //chkEmployee[0].WHTOther = this.PettycashFrom.get('txtWHTOther').value
        }

      }

      //Invoice Type No Vat
      //if (this.PettycashFrom.value['cbVat'] == 1) {
      this.currency = this.PettycashFrom.get('ddlUOM').value;
      this.lstTreqiTm.push({
        vendor: this.PettycashFrom.get('txtVendorCode_PX').value
        , vName: this.PettycashFrom.get('txtVendorName_PX').value
        , TaxID: this.PettycashFrom.get('txtTaxID_PX').value
        , address: this.PettycashFrom.get('txtAddress_PX').value
        , cbOffice: this.PettycashFrom.get('cbOffice_PX').value
        , BranchCode: this.PettycashFrom.get('txtBranchCode_PX').value
        , dInvoice: this.System._ParseDateToFormat(new Date(O_date), "yyyy-MM-dd")
        , Invoice: this.PettycashFrom.get('txtInvoice').value
        , TotalAmountInvoice: this.ConvertCurrentTonumber(this.PettycashFrom.get('txtTotalAmountInvoice').value).toFixed(2)
        , currency: this.PettycashFrom.get('ddlUOM').value
        , TotalAmountVat: this.ConvertCurrentTonumber(this.PettycashFrom.get('txtTotalAmountVat').value).toFixed(2)
        , VatAmount: this.PettycashFrom.get('txtVatAmount').value == null ? null : (this.ConvertCurrentTonumber(this.PettycashFrom.get('txtVatAmount').value)).toFixed(2)
        , WithholdingRate: this.RateWHT == null ? '0.00' : this.RateWHT.toFixed(2)
        , WithholdingRate2: this.RateWHT2 == null ? '0.00' : this.RateWHT2.toFixed(2)
        , WithholdingVal: this.PettycashFrom.get('ddlWithholdingTax').value == "" ? null : WHDVal.toFixed(2)
        , WithholdingVal2: this.PettycashFrom.get('ddlWithholdingTax2').value == "" ? null : WHDVal2.toFixed(2)
        , WithholdingTax: this.PettycashFrom.get('ddlWithholdingTax').value
        , WithholdingTax2: this.PettycashFrom.get('ddlWithholdingTax2').value
        , WHTOther: this.PettycashFrom.get('txtWHTOther').value
        , WHTOther2: this.PettycashFrom.get('txtWHTOther2').value
        , nWHTBase: this.PettycashFrom.get('nWHTBase').value
        , nWHTBase2: this.PettycashFrom.get('nWHTBase2').value
        , Vattype: this.PettycashFrom.get('ddlVatType').value
        , nItem: ++this.nItem
        , cVenderMaster: "N"
        , nInvoiceType: this.PettycashFrom.get('cbVat').value
        , IsDelete: false
        , sCountryID: this.PettycashFrom.get('sCountryID').value
        , sProvCode: this.PettycashFrom.get('sProvCode').value
        , sAmpCode: this.PettycashFrom.get('sAmpCode').value
        , sTumbonCode: this.PettycashFrom.get('sTumbonCode').value
        , sCountryName: this.PettycashFrom.get('sCountryName').value
        , sProvName: this.PettycashFrom.get('sProvName').value
        , sAmpName: this.PettycashFrom.get('sAmpName').value
        , sTumbonName: this.PettycashFrom.get('sTumbonName').value
        , sPostCode: this.PettycashFrom.get('sPostCode').value
        , sPhoneNumber: this.PettycashFrom.get('sPhoneNumber').value
        , sFaxNumber: this.PettycashFrom.get('sFaxNumber').value
        , sVendorEmail: this.PettycashFrom.get('sVendorEmail').value
        , sVendorAddress: this.PettycashFrom.get('sVendorAddress').value
        , IsOneTimeVendor: this.IsOneTimeVendor
      })
      //move data in arrGl to TreqLine
      for (var i = 0; i < this.ArrGL.length; i++) {
        let Isdelete = this.ArrGL.value[i].IsDelete
        if (!Isdelete) {
          this.rows.push({
            Invoice: this.PettycashFrom.value['txtInvoice']
            , type: this.PettycashFrom.get('ddlVatType').value
            , GL: this.ArrGL.value[i].txtGL
            , costcenter: this.ArrGL.value[i].txtCostCenter
            , desc: this.ArrGL.value[i].txtText
            , IO: this.ArrGL.value[i].txtIO === "Not Require IO (N/A)" ? null : this.ArrGL.value[i].txtIO
            , amount: this.ConvertCurrentTonumber(this.ArrGL.value[i].txtAmountExcludedVAT).toFixed(2)
            , del: this.ArrGL.value[i].IsDelete
            , nItem: this.nItem
            , nLine: i + 1
            , WHDRate: this.RateWHT == null ? null : this.RateWHT.toFixed(2)
            , WHDRate2: this.RateWHT2 == null ? null : this.RateWHT2.toFixed(2)
            , WHDtax: this.PettycashFrom.value['ddlWithholdingTax']
            , WHDtax2: this.PettycashFrom.value['ddlWithholdingTax2']
            , Time: new Date(O_date)

          })
        }
      }
      //event after(calculate amout ,clear arrGl) add or update data to Treq
      this.IsNoData = false
      this.Invoice.push(this.PettycashFrom.value['txtInvoice'])
      this.InvoiceDate.push(O_date)
      this.setAmount();
      this.ClearInvoice();
      //this.Clear();
      this.PettycashFrom.get('ddlUOM').disable();
    } else if (chk == false) {
      this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Invoice_TotalNoMatch, function () { })
    } else {
      this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Error, function () { })
    }
  }

  //clear form invoice
  ClearInvoice() {
    let FieldValid = ['txtInvoice', 'txtTotalAmountVat', 'txtInvoiceDate', 'txtVatAmount', 'ddlVatType', 'txtWHTOther', 'txtWHTOther2']
    FieldValid.forEach(data => this.PettycashFrom.get(data).markAsUntouched())
    this.PettycashFrom.patchValue({
      txtInvoice: "",
      txtTotalAmountInvoice: "",
      txtVatAmount: "",
      txtInvoiceDate: new Date(),
      //ddlVatType: "",
      txtTotalAmountVat: null,
      ddlWithholdingTax: "",
      ddlWithholdingTax2: "",
      txtWHTOther: null,
      txtWHTOther2: null,
      txtWHTAmount: null,
      _txtWHTAmount: null,
      txtWHTAmount2: null,
      _txtWHTAmount2: null,
      nWHTBase: null,
      nWHTBase2: null,
      //cbVat: 1,
    });
    this.IsEdit = false;
    this.IsOneTimeVendor = false;
    this.PettycashFrom.get('txtWHTOther').disable();
    this.PettycashFrom.get('txtWHTOther2').disable();
    //this.onselectWGT();
    //this.cbVATorWHT();
    this.ArrGL.clear();
    this.AddGL();
    this.DataIO.push([]);
    this.CalTotalAmount(false);
  }

  IsEdit: boolean = false;
  IsAdd = true;

  //add &edit invoice "check condition before sent to next step"
  async AddInvoice(index: string) {
    let _this = this;
    let Ischk = true;
    let _FormGroup = this.PettycashFrom;
    //#region "validator input from form control"
    //let fieldName = ['txtVendorCode', 'txtTaxID', 'txtAddress', 'txtVendorCode_PX', 'txtTaxID', 'txtAddress_PX']
    let fieldName = ['txtVendorCode', 'txtVendorCode_PX'];
    for (var i = 0; i < fieldName.length; i++) {
      if (this.PettycashFrom.get(fieldName[i]).value == null) {
        Ischk = false;
        break;
      }

    }
    var FieldValid: string[] = [];
    if (this.PettycashFrom.get('cbVat').value == 1) {
      FieldValid = ['txtVendorCode', 'txtInvoice', 'txtTotalAmountVat', 'txtVatAmount', 'ddlVatType', 'txtVendorCode_PX'];
      //if (this.PettycashFrom.get('txtVendorCode').value == null && this.PettycashFrom.get('txtVendorCode_PX').value == null) {
      //  FieldValid = ['txtVendorCode', 'txtInvoice', 'txtTotalAmountVat'
      //    , 'txtVatAmount', 'ddlVatType', 'txtVendorCode_PX'
      //  ];
      //} else {
      //  FieldValid = ['txtVendorCode', 'txtInvoice', 'txtTotalAmountVat', 'txtVatAmount', 'ddlVatType', 'txtVendorCode_PX'];
      //}

    } else {
      FieldValid = ['txtVendorCode', 'txtInvoice', 'txtTotalAmountVat', 'txtVatAmount', 'ddlVatType'];
      //if (this.PettycashFrom.get('txtVendorCode').value == null && this.PettycashFrom.get('txtVendorCode_PX').value == null) {
      //  FieldValid = ['txtVendorCode', 'txtInvoice', 'txtTotalAmountVat'
      //    , 'txtVendorCode_PX'
      //    , 'txtVendorName_PX', 'txtTaxID_PX', 'txtAddress_PX', 'txtVendorName', 'txtTaxID', 'txtAddress'
      //  ];
      //} else {
      //  FieldValid = ['txtVendorCode', 'txtInvoice', 'txtTotalAmountVat'
      //    , 'txtVendorCode_PX'
      //  ];
      //}

    }

    if (this.PettycashFrom.get('ddlVatType').value == "VZ") {
      FieldValid = FieldValid.filter(f => f != "ddlVatType");
    }

    if (this.IsOneTimeVendor) {
      if (this.nCountryID == "213") {
        FieldValid.push('sCountryName', 'sProvName', 'sAmpName', 'sTumbonName'
          , 'txtVendorName_PX');
      } else {
        FieldValid.push('sCountryName', 'sProvName');
      }
    }
    if (this.PettycashFrom.value['ddlWithholdingTax'] == "99" || this.PettycashFrom.value['ddlWithholdingTax'] == "6") {
      FieldValid.push('txtWHTOther');
    }
    if (this.PettycashFrom.value['ddlWithholdingTax2'] == "99" || this.PettycashFrom.value['ddlWithholdingTax2'] == "6") {
      FieldValid.push('txtWHTOther2');
    }

    if (this.PettycashFrom.get('ddlVatType').value == "VZ") {
      FieldValid = FieldValid.filter(f => f != "txtVatAmount");
    }
    let IsValid: boolean = true;
    FieldValid.forEach(function (Field) {
      if (!_FormGroup.get(Field).valid) {
        IsValid = false;
        return false;
      }
    });

    //เช็ค ArrGL
    if (IsValid) {
      let FieldGLValid: string[] = ["txtGL", "txtCostCenter", "txtIO", "txtAmountExcludedVAT", "txtText"];
      if (!this.IsIO) {
        FieldGLValid = FieldGLValid.filter(f => f != "txtIO")
      }
      if (!this.IsGL) {
        FieldGLValid = FieldGLValid.filter(f => f != "txtGL")
      }
      for (let i = 0; i < this.ArrGL.length; i++) {
        FieldGLValid.forEach(function (Field) {
          let FromArray = _FormGroup.get('ArrGL') as FormArray;
          if (!FromArray.at(i).get(Field).valid) {
            IsValid = false;
            return false;
          }
        });
      }
    }
    //#endregion
    //#region "check dup invoice no in day"
    //let O_date = new Date(this.PettycashFrom.value['txtInvoiceDate']).setHours(0, 0, 0, 0)
    let O_date = this.System._ParseDateToFormat(new Date(this.PettycashFrom.get('txtInvoiceDate').value), 'yyyy-MM-dd');
    let _Date = new Date(this.PettycashFrom.value['txtInvoiceDate'])
    //let Arrdate = _Date.split("/")
    let invoice = this.PettycashFrom.value['txtInvoice'] == "" ? "null" : this.PettycashFrom.value['txtInvoice']
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })

    let IsDateInvoice = false;
    IsDateInvoice = this.InvoiceDate.includes(O_date)

    let Dupinvoice = false;
    //check Dup Invoice
    var lstDup = this.lstTreqiTm.filter(f => f.Invoice == this.PettycashFrom.get('txtInvoice').value
      && this.System._ParseDateToFormat(f.dInvoice, "yyyy-MM-dd") == this.System._ParseDateToFormat(this.PettycashFrom.get('txtInvoiceDate').value, "yyyy-MM-dd")
      && f.IsDelete == false && f.cVenderMaster == "N");
    Dupinvoice = lstDup.length > 0 ? false : true;    //check Dup Invoice Date
    // Check in DB
    let _ChkInvoice = false;
    let sReqID = this.ReqID
    let ChkDup = {
      invoice: invoice,
      sDate: this.System._ParseDateToFormat(_Date, 'yyyy,MM-dd'),
      sReqID: sReqID,
      sCompcode: this.sComCode
    };
    let DataEdit = JSON.stringify(ChkDup)
    //#endregion
    //#region "Add and update Req No"
    let TotalAmount = this.ConvertCurrentTonumber(this.PettycashFrom.value['txtTotalAmountVat']);
    let nWHTBase = this.ConvertCurrentTonumber(this.PettycashFrom.value['nWHTBase']);
    let nWHTBase2 = this.ConvertCurrentTonumber(this.PettycashFrom.value['nWHTBase2']);
    let base = nWHTBase + nWHTBase2;
    if (TotalAmount !== base && nWHTBase !== 0 && nWHTBase !== undefined && nWHTBase2 !== undefined) {
      _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Base_TotalNoMatch, undefined)
    }
    else if (IsValid) {
      //Cread New Req
      if (index == "Add") {
        await this.http.post<any>(this.System.SiteName + "api/PettyCash/CheckInvoice", DataEdit, { headers }).toPromise().then(data => {
          _ChkInvoice = data;

          this.IsEdit = false;
          if (Dupinvoice && _ChkInvoice) { //check in Cliant
            this.createtable();
            //#region 2021-01-21 Log Save Invoice
            const options = { headers: { 'Content-Type': 'application/json' } };
            _this.http.post<any>(_this.System.SiteName + "api/PaytoEmployee/LogInvoice", JSON.stringify({
              nReqID: sReqID,
              TreqIm: this.lstTreqiTm,
              TreqLn: this.rows
            }), options).subscribe(res => {

            })
            //#endregion
          } else {
            this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Receipt_Duplicate, function () { })
          }
        });
        //Update
      } else if (index == "Update") {
        await this.http.post<any>(this.System.SiteName + "api/PettyCash/CheckInvoice_Edit", DataEdit, { headers }).toPromise().then(data => {
          _ChkInvoice = data;

          // Check in DB
          let DupItem = this.lstTreqiTm.filter(f => f.nItem != this._EdnItem && f.Invoice == this.PettycashFrom.get('txtInvoice').value
            && this.System._ParseDateToFormat(f.dInvoice, "yyyy-MM-dd") == this.System._ParseDateToFormat(this.PettycashFrom.get('txtInvoiceDate').value, "yyyy-MM-dd")
            && f.cVenderMaster == 'N')
          let IsDupItem = DupItem.length == 0 ? true : false;

          if (!_ChkInvoice && IsDupItem) {
            let dates = new Date(O_date);

            let _lstEdit = this.lstTreqiTm.filter(f => f.nItem != this._EdnItem && f.Invoice == invoice);
            let _DupInvoice = _lstEdit.filter(f => f.Invoice == invoice).length > 0 ? false : true;
            let _hour = _lstEdit.map(f => new Date(f.dInvoice).toLocaleString('en'))
            let arrHour = _hour.filter(f => f == O_date).length > 0 ? false : true
            let TotalAmount = this.ConvertCurrentTonumber(this.PettycashFrom.value['txtTotalAmountVat']);
            let totalGL = 0;
            for (var i = 0; i < this.ArrGL.length; i++) {
              let Isdelete = this.ArrGL.value[i].IsDelete
              if (!Isdelete) {
                let AmountExcludedVAT = parseFloat(this.ArrGL.value[i].txtAmountExcludedVAT);
                totalGL = totalGL + AmountExcludedVAT
              }
            }
            let chk = TotalAmount == totalGL ? true : false;
            if (chk) {
              if (_DupInvoice || arrHour) {
                this.SaveEdit();
                this.IsEdit = false;
                //#region 2021-01-21 Log Save Invoice
                const options = { headers: { 'Content-Type': 'application/json' } };
                _this.http.post<any>(_this.System.SiteName + "api/PaytoEmployee/LogInvoice", JSON.stringify({
                  nReqID: sReqID,
                  TreqIm: this.lstTreqiTm,
                  TreqLn: this.rows
                }), options).subscribe(res => {

                })
                //#endregion
              } else {
                this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Receipt_Duplicate, function () { })
              }
            }
            else {
              this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Invoice_TotalNoMatch, function () { })
            }
          } else {
            this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Receipt_Duplicate, function () { })
          }
        });
      }
    }
    else {
      this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Warning_Information, function () {
        FieldValid.forEach(function (Field) {
          const control = _FormGroup.get(Field);             //{3}
          if (control instanceof FormControl) {             //{4}
            control.markAsTouched({ onlySelf: true });
          }
        });
        let FieldGLValid: string[] = ["txtGL", "txtCostCenter", "txtIO", "txtAmountExcludedVAT","txtText"];
        if (!_this.IsIO) {
          FieldGLValid = FieldGLValid.filter(f => f != "txtIO")
        }
        if (!_this.IsGL) {
          FieldGLValid = FieldGLValid.filter(f => f != "txtGL")
        }
        for (let i = 0; i < _this.ArrGL.length; i++) {
          FieldGLValid.forEach(function (Field) {
            let FromArray = _FormGroup.get('ArrGL') as FormArray;
            const control = FromArray.at(i).get(Field);             //{3}
            if (control instanceof FormControl) {             //{4}
              control.markAsTouched({ onlySelf: true });
            }
          });
        }
      })

    }

    //#endregion
  }


  //save edit: event next from Addinvoice if condition pass
  async SaveEdit() {
    let totalGL = 0;
    let WHDVal = 0;
    let WHDVal2 = 0;
    let nWHTBase = 0;
    let nWHTBase2 = 0;
    let nItem = this._EdnItem;
    let nLine = this._EdnLine;
    if (!isUndefined(this.indexDel)) {
      let lstDel = this.rows.filter(item => item.nItem == this.ArrGL.value[this.indexDel].nItem && item.nLine == this.ArrGL.value[this.indexDel].nLine)
      lstDel.forEach(index => index.del = true)
    }
    for (var i = 0; i < this.ArrGL.length; i++) {
      let Isdelete = this.ArrGL.value[i].IsDelete
      if (!Isdelete) { //check total WHDtax
        let AmountExcludedVAT = this.ConvertCurrentTonumber(this.ArrGL.value[i].txtAmountExcludedVAT);
        totalGL = totalGL + AmountExcludedVAT
      }
    }

    let txtWHTAmount = this.setfloat(this.PettycashFrom.value['txtWHTAmount']);
    let txtWHTAmount2 = this.setfloat(this.PettycashFrom.value['txtWHTAmount2']);
    let txtnWHTBase = this.setfloat(this.PettycashFrom.value['nWHTBase']);
    let txtnWHTBase2 = this.setfloat(this.PettycashFrom.value['nWHTBase2']);

    WHDVal = WHDVal + txtWHTAmount + 0.00;
    WHDVal2 = WHDVal2 + txtWHTAmount2 + 0.00;

    nWHTBase = nWHTBase + txtnWHTBase + 0.00;
    nWHTBase2 = nWHTBase2 + txtnWHTBase2 + 0.00;

    let O_date = new Date(this.PettycashFrom.value['txtInvoiceDate']).setHours(0, 0, 0, 0);
    let _lstTreqiTm = this.lstTreqiTm.filter(data => data.Invoice == this._invoice && data.nItem == nItem && data.IsDelete != true)


    for (var i = 0; i < _lstTreqiTm.length; i++) {
      //Check VenderMaster = M
      if (_lstTreqiTm[i].cVenderMaster == "M") {
        _lstTreqiTm[i].vendor = this.PettycashFrom.get('txtVendorCode').value
        _lstTreqiTm[i].vName = this.PettycashFrom.get('txtVendorName').value
        _lstTreqiTm[i].TaxID = this.PettycashFrom.get('txtTaxID').value
        _lstTreqiTm[i].address = this.PettycashFrom.get('txtAddress').value
        _lstTreqiTm[i].cbOffice = this.PettycashFrom.get('cbOffice').value
        _lstTreqiTm[i].BranchCode = this.PettycashFrom.get('txtBranchCode').value
        //_lstTreqiTm[i].dInvoice = new Date(O_date)
        //_lstTreqiTm[i].Invoice = this.PettycashFrom.get('txtInvoice').value
        //_lstTreqiTm[i].currency = this.PettycashFrom.get('ddlUOM').value
        //_lstTreqiTm[i].Vattype = this.PettycashFrom.get('ddlVatType').value
        _lstTreqiTm[i].cVenderMaster = "M"
        //_lstTreqiTm[i].nInvoiceType = this.PettycashFrom.get('cbVat').value
        _lstTreqiTm[i].IsDelete = false
        //_lstTreqiTm[i].TotalAmountInvoice = this.ConvertCurrentTonumber(this.PettycashFrom.get('txtTotalAmountInvoice').value).toFixed(2)
        //_lstTreqiTm[i].TotalAmountVat = this.ConvertCurrentTonumber(this.PettycashFrom.get('txtTotalAmountVat').value).toFixed(2)
        //_lstTreqiTm[i].VatAmount = this.PettycashFrom.get('txtVatAmount').value == "" ? null : this.ConvertCurrentTonumber(this.PettycashFrom.get('txtVatAmount').value).toFixed(2)
        //_lstTreqiTm[i].WithholdingRate = this.RateWHT == 0 ? '0.00' : this.RateWHT.toFixed(2)
        //_lstTreqiTm[i].WithholdingVal = null
        //_lstTreqiTm[i].WithholdingTax = this.PettycashFrom.get('ddlWithholdingTax').value
        //_lstTreqiTm[i].WHTOther = this.PettycashFrom.get('txtWHTOther').value


      }
      else {
        //Check VenderMaster = N
        //if (this.PettycashFrom.get('cbVat').value == 1) {
        //Check Old VenderMaster = N แก้ ref เดิม
        if (_lstTreqiTm[i].cVenderMaster == "N") {
          _lstTreqiTm[i].vendor = this.PettycashFrom.get('txtVendorCode_PX').value
          _lstTreqiTm[i].vName = this.PettycashFrom.get('txtVendorName_PX').value
          _lstTreqiTm[i].TaxID = this.PettycashFrom.get('txtTaxID_PX').value
          _lstTreqiTm[i].address = this.PettycashFrom.get('txtAddress_PX').value
          _lstTreqiTm[i].cbOffice = this.PettycashFrom.get('cbOffice_PX').value
          _lstTreqiTm[i].BranchCode = this.PettycashFrom.get('txtBranchCode_PX').value
          _lstTreqiTm[i].dInvoice = this.System._ParseDateToFormat(new Date(O_date), "yyyy-MM-dd")
          _lstTreqiTm[i].Invoice = this.PettycashFrom.get('txtInvoice').value
          _lstTreqiTm[i].TotalAmountInvoice = this.ConvertCurrentTonumber(this.PettycashFrom.get('txtTotalAmountInvoice').value).toFixed(2)
          _lstTreqiTm[i].currency = this.PettycashFrom.get('ddlUOM').value
          _lstTreqiTm[i].TotalAmountVat = this.ConvertCurrentTonumber(this.PettycashFrom.get('txtTotalAmountVat').value).toFixed(2)
          _lstTreqiTm[i].VatAmount = this.PettycashFrom.get('txtVatAmount').value == null ? null : this.ConvertCurrentTonumber(this.PettycashFrom.get('txtVatAmount').value).toFixed(2)
          _lstTreqiTm[i].WithholdingRate = this.RateWHT == 0 || this.RateWHT == null ? '0.00' : this.RateWHT.toFixed(2)
          _lstTreqiTm[i].WithholdingRate2 = this.RateWHT2 == 0 || this.RateWHT2 == null ? '0.00' : this.RateWHT2.toFixed(2)
          _lstTreqiTm[i].WithholdingVal = this.PettycashFrom.get('ddlWithholdingTax').value == "" ? null : WHDVal.toFixed(2)
          _lstTreqiTm[i].WithholdingVal2 = this.PettycashFrom.get('ddlWithholdingTax2').value == "" ? null : WHDVal2.toFixed(2)
          _lstTreqiTm[i].nWHTBase = this.PettycashFrom.get('nWHTBase').value == "" ? null : nWHTBase.toFixed(2)
          _lstTreqiTm[i].nWHTBase2 = this.PettycashFrom.get('nWHTBase2').value == "" ? null : nWHTBase2.toFixed(2)
          _lstTreqiTm[i].WithholdingTax = this.PettycashFrom.get('ddlWithholdingTax').value
          _lstTreqiTm[i].WithholdingTax2 = this.PettycashFrom.get('ddlWithholdingTax2').value
          _lstTreqiTm[i].WHTOther = this.PettycashFrom.get('txtWHTOther').value
          _lstTreqiTm[i].WHTOther2 = this.PettycashFrom.get('txtWHTOther2').value
          _lstTreqiTm[i].Vattype = this.PettycashFrom.get('ddlVatType').value
          _lstTreqiTm[i].nItem = nItem
          _lstTreqiTm[i].cVenderMaster = "N"
          _lstTreqiTm[i].nInvoiceType = this.PettycashFrom.get('cbVat').value
          _lstTreqiTm[i].IsDelete = false
          _lstTreqiTm[i].sCountryID = this.PettycashFrom.get('sCountryID').value + ""
          _lstTreqiTm[i].sCountryName = this.PettycashFrom.get('sCountryName').value
          _lstTreqiTm[i].sProvCode = this.PettycashFrom.get('sProvCode').value
          _lstTreqiTm[i].sProvName = this.PettycashFrom.get('sProvName').value
          _lstTreqiTm[i].sAmpCode = this.PettycashFrom.get('sAmpCode').value
          _lstTreqiTm[i].sAmpName = this.PettycashFrom.get('sAmpName').value
          _lstTreqiTm[i].sTumbonCode = this.PettycashFrom.get('sTumbonCode').value
          _lstTreqiTm[i].sTumbonName = this.PettycashFrom.get('sTumbonName').value
          _lstTreqiTm[i].sPostCode = this.PettycashFrom.get('sPostCode').value
          _lstTreqiTm[i].sPhoneNumber = this.PettycashFrom.get('sPhoneNumber').value
          _lstTreqiTm[i].sFaxNumber = this.PettycashFrom.get('sFaxNumber').value
          _lstTreqiTm[i].sVendorEmail = this.PettycashFrom.get('sVendorEmail').value
          _lstTreqiTm[i].sVendorAddress = this.PettycashFrom.get('sVendorAddress').value
          _lstTreqiTm[i].IsOneTimeVendor = this.IsOneTimeVendor
        }

      }

    }

    this.IsEdit = true;
    let lstEd = this.rows.filter(item => item.nItem == nItem);
    lstEd.forEach(f => f.del = true);
    let _ArrGL = this.ArrGL.value.filter(f => f.IsDelete != true);
    for (var i = 0; i < _ArrGL.length; i++) {
      let WTx = 0;
      let WTx2 = 0;
      if (this.PettycashFrom.value['ddlWithholdingTax'] == "99" || this.PettycashFrom.value['ddlWithholdingTax'] == "6") {
        WTx = this.ConvertCurrentTonumber(this.PettycashFrom.get('txtWHTOther').value)
      } else {
        let _WTx = this.WithholdingTax.filter(data => data.nWHTID == this.PettycashFrom.value['ddlWithholdingTax'])
        WTx = _WTx.length == 0 ? 0 : _WTx[0].nRate
      }
      if (this.PettycashFrom.value['ddlWithholdingTax2'] == "99" || this.PettycashFrom.value['ddlWithholdingTax2'] == "6") {
        WTx2 = this.ConvertCurrentTonumber(this.PettycashFrom.get('txtWHTOther2').value)
      } else {
        let _WTx2 = this.WithholdingTax.filter(data => data.nWHTID == this.PettycashFrom.value['ddlWithholdingTax2'])
        WTx2 = _WTx2.length == 0 ? 0 : _WTx2[0].nRate
      }
      if (lstEd[i] != null) {
        lstEd[i].Invoice = this.PettycashFrom.value['txtInvoice'];
        lstEd[i].type = this.PettycashFrom.get('ddlVatType').value;
        lstEd[i].GL = _ArrGL[i].txtGL;
        lstEd[i].costcenter = _ArrGL[i].txtCostCenter;
        lstEd[i].desc = _ArrGL[i].txtText;
        lstEd[i].IO = _ArrGL[i].txtIO === "Not Require IO (N/A)" ? null : _ArrGL[i].txtIO;
        lstEd[i].amount = this.ConvertCurrentTonumber(_ArrGL[i].txtAmountExcludedVAT).toFixed(2);
        lstEd[i].nItem = nItem;
        lstEd[i].nLine = i + 1;
        lstEd[i].WHDRate = WTx.toFixed(2);
        lstEd[i].WHDtax = this.PettycashFrom.value['ddlWithholdingTax'];
        lstEd[i].WHDtax2 = this.PettycashFrom.value['ddlWithholdingTax2'];
        lstEd[i].Time = new Date(O_date);
        lstEd[i].del = _ArrGL[i].IsDelete;
      }
      else {
        this.rows.push({
          Invoice: this.PettycashFrom.value['txtInvoice']
          , type: this.PettycashFrom.get('ddlVatType').value
          , GL: this.ArrGL.value[i].txtGL
          , costcenter: this.ArrGL.value[i].txtCostCenter
          , desc: this.ArrGL.value[i].txtText
          , IO: this.ArrGL.value[i].txtIO
          , amount: this.ConvertCurrentTonumber(this.ArrGL.value[i].txtAmountExcludedVAT).toFixed(2)
          , del: this.ArrGL.value[i].IsDelete
          , nItem: nItem
          , nLine: i + 1
          , WHDRate: WTx.toFixed(2)
          , WHDtax: this.PettycashFrom.value['ddlWithholdingTax']
          , WHDtax2: this.PettycashFrom.value['ddlWithholdingTax2']
          , Time: new Date(O_date)
        })
      }
    }
    this.rows = _.orderBy(this.rows, ["nItem"], ["asc"]);
    this.ClearInvoice();
    this.Clear();
    this.setAmount();
    if (this.rows.length == 0) {
      this.IsNoData = true //set No data Table
      this.Invoice = [];
    }
  }
  //export pdf
  Export() {
    const link = document.createElement('a');
    link.target = '_blank'
    const httpOptions = {
      params: new HttpParams()
        .set("sReqID", this.ReqID + "")
        .set("nContactID", this.ContactID),
    };
    link.href = this.System.SiteName + "api/ExportPDF/export?" + httpOptions.params
    link.setAttribute('visibility', 'hidden');
    link.click();
    this.System.UnBlockUI();
  }
  //check empty arrGl
  checkEmptyArrGL() {
    for (var i = 0; i < this.ArrGL.length; i++) {
      if (this.ArrGL.value[i].IsDelete == false) {
        if (this.ArrGL.value[i].txtGL == "") {
          return false;
        } else if (this.ArrGL.value[i].txtCostCenter == "") {
          return false;
        } else if (this.ArrGL.value[i].txtIO == "") {
          return false;
        } else if (this.ArrGL.value[i].txtAmountExcludedVAT == "") {
          return false;
        } else {
          return true;
        }
      }
    }
  }

  //set format AmountExcludedVAT (onchange)
  setformat() {
    let TotalAmount = this.ArrGL.value[0].txtAmountExcludedVAT
    this.ArrGL.value[0].txtAmountExcludedVAT = parseFloat(TotalAmount).toFixed(2)
  }
  RateWHT = 0;
  RateWHT2 = 0;

  KeyWithholdingAmount(mode: number){
    const _this = this;
    let WHTType = this.PettycashFrom.value['ddlWithholdingTax']
    if (WHTType) {
      let nWHTVal: number = 0;
      let _nWHTVal: number = 0;
      let nWHTValNew: any;
      let _nWHTValNew: any;
      if (mode == 1) {
          nWHTVal = this.PettycashFrom.value['txtWHTAmount'] == null ? null : parseFloat(this.PettycashFrom.value['txtWHTAmount'])
          _nWHTVal = this.PettycashFrom.value['_txtWHTAmount'] == null ? null : parseFloat(this.PettycashFrom.value['_txtWHTAmount'])
          nWHTValNew = _this.PettycashFrom.value.txtWHTAmount;
          _nWHTValNew = _this.PettycashFrom.value._txtWHTAmount;
      }
      else {
        nWHTVal = this.PettycashFrom.value['txtWHTAmount2'] == null ? null : parseFloat(this.PettycashFrom.value['txtWHTAmount2'])
        _nWHTVal = this.PettycashFrom.value['_txtWHTAmount2'] == null ? null : parseFloat(this.PettycashFrom.value['_txtWHTAmount2'])
        nWHTValNew = _this.PettycashFrom.value.txtWHTAmount2;
        _nWHTValNew = _this.PettycashFrom.value._txtWHTAmount2;
      }
      if (Math.abs(nWHTVal - _nWHTVal) > 1){
        nWHTValNew = _nWHTValNew;
        _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Error_Amount, null)
      }
      if (mode == 1) {
        _this.PettycashFrom.patchValue({
          txtWHTAmount: nWHTValNew,
          _txtWHTAmount: _nWHTValNew,
        });
      }
      else {
        _this.PettycashFrom.patchValue({
          txtWHTAmount2: nWHTValNew,
          _txtWHTAmount2: _nWHTValNew,
        })
      }
    }
  }

  KeyWithholdingBase(event: any, mode: number) {
    // let nWHTVal = this._ConvertToDecimal((Number(event.target.value)).toFixed(2));
    if (event.target.value === '') {
      if (mode === 1) {
        this.PettycashFrom.patchValue({
          nWHTBase: '0.00',
        });
      }
      else {
        this.PettycashFrom.patchValue({
          nWHTBase2: '0.00',
        })
      }
    }
  }

  //set WithholdingTax
  onselectWGT(mode: number, isSetValue: boolean) {
    if (mode === 1) {
      let WHTType = this.PettycashFrom.value['ddlWithholdingTax']
      let WTx = this.WithholdingTax.filter(data => data.nWHTID == WHTType)
      this.hVatAmount = WHTType == "99" || WHTType == "6" ? true : false
      if (this.hVatAmount) {
        this.RateWHT = this.PettycashFrom.value['txtWHTOther'] == null ? null : parseFloat(this.PettycashFrom.value['txtWHTOther'])
        this.PettycashFrom.get('txtWHTOther').enable()
       
      } else {
        this.RateWHT = WTx.length == 0 ? "" : WTx[0].nRate;
        this.PettycashFrom.patchValue({ txtWHTOther: "" })
        this.PettycashFrom.get('txtWHTOther').disable()
        this.PettycashFrom.get('txtWHTOther').reset()
      }
      if (isSetValue) this.onSetWHTValue(1, false);
    }
    else {
      let WHTType2 = this.PettycashFrom.value['ddlWithholdingTax2']
      let WTx2 = this.WithholdingTax.filter(data => data.nWHTID == WHTType2)
      this.hVatAmount2 = WHTType2 == "99" || WHTType2 == "6" ? true : false
      if (this.hVatAmount2) {
        this.RateWHT2 = this.PettycashFrom.value['txtWHTOther2'] == null ? null : parseFloat(this.PettycashFrom.value['txtWHTOther2'])
        this.PettycashFrom.get('txtWHTOther2').enable()
      } else {
        this.RateWHT2 = WTx2.length == 0 ? "" : WTx2[0].nRate;
        this.PettycashFrom.patchValue({ txtWHTOther2: "" })
        this.PettycashFrom.get('txtWHTOther2').disable()
        this.PettycashFrom.get('txtWHTOther2').reset()
      }
      if (isSetValue) this.onSetWHTValue(2, false);
    }
  }

  onSetWHTValue(mode: number, byTotal){
    let total = this.ConvertCurrentTonumber(this.PettycashFrom.value['txtTotalAmountVat'])
    if (mode === 1) {
      let WTHAmount = '0.00';
      let WHTBase = '0.00';
      if (this.PettycashFrom.value['ddlWithholdingTax']) {
        let nWHTBase = this.ConvertCurrentTonumber(this.PettycashFrom.value['nWHTBase'])
        if (!byTotal && nWHTBase > 0) total = nWHTBase;
        WTHAmount = this.formatnumber(2, true, (this.RateWHT / 100) * total);
        WHTBase = this.formatnumber(2, true, total);
      }
      this.PettycashFrom.patchValue({ 
        txtWHTAmount: WTHAmount,
        _txtWHTAmount: WTHAmount,
        nWHTBase: WHTBase
       })
    }
    else{
      let WTHAmount2 = '0.00';
      let WHTBase2 = '0.00';
      if (this.PettycashFrom.value['ddlWithholdingTax2']) {
        total = this.ConvertCurrentTonumber(this.PettycashFrom.value['nWHTBase2'])
        WTHAmount2 = this.formatnumber(2, true, (this.RateWHT2 / 100) * total);
        WHTBase2 = this.formatnumber(2, true, total);
      }
      this.PettycashFrom.patchValue({ 
        txtWHTAmount2: WTHAmount2,
        _txtWHTAmount2: WTHAmount2,
        nWHTBase2: WHTBase2
       })
    }
  }

  //set vat rate of WithholdingTax
  setVatRate(mode: number) {
    if (mode === 1) {
      let RateWHT = this.ConvertCurrentTonumber(this.PettycashFrom.value['txtWHTOther'])
      this.RateWHT = RateWHT
      this.onSetWHTValue(1, false);
    }
    else {
      let RateWHT2 = this.ConvertCurrentTonumber(this.PettycashFrom.value['txtWHTOther2'])
      this.RateWHT2 = RateWHT2
      this.onSetWHTValue(2, false);
    }      
  }

  isSkip: boolean = false;
  //skip appover 1
  chkSkip() {
    let chk = this.PettycashFrom.value['chkApprove1']
    if (chk) {
      this.PettycashFrom.controls['txtApprove1'].setValue("");
      this.PettycashFrom.controls['txtApprove1'].setErrors(null);
      this.PettycashFrom.controls['txtApprove1'].clearValidators();
      this.PettycashFrom.controls['txtApprove1'].disable();
      this.PettycashFrom.controls['txtApprove1'].markAsUntouched();
      this.isSkip = true;
    } else {
      //this.PettyCashFrom.get('txtApprove1').enable()
      this.PettycashFrom.patchValue({ txtApprove1: this.ApproveName1 })
      this.PettycashFrom.controls['txtApprove1'].setValidators(Validators.required);
      this.PettycashFrom.controls['txtApprove1'].updateValueAndValidity();
      this.PettycashFrom.controls['txtApprove1'].enable();

    }
  }

  IsCheque: boolean = true;
  // set bamk transfer
  _cbChequeType(event: any) {
    let chk = this.PettycashFrom.value['_cbChequeType']
    let comcode = this.PettycashFrom.value['sComCode']
    if (event == 1) {
      this.chkOther = false;
      this.IsCheque = true
      let ChequeType = this.DataBank.filter(data => data.Cheque == 'Y' && data.Company == comcode);
      this._DataBank = ChequeType;
      this.PettycashFrom.get('txtBankAccountNo').disable()
      this.PettycashFrom.get('ddlBank').disable()
      this.BankAccountNo = [];
      this.PettycashFrom.get('txtBankBranch').disable()
      this.PettycashFrom.get('lblBankAccountName').disable()
      this.PettycashFrom.get('Bankother').disable()
      this.PettycashFrom.patchValue({ txtBankAccountNo: "", txtBankBranch: "", lblBankAccountName: "", ddlBank: "", Bankother: "" })
      this.PettycashFrom.get('txtBankAccountNo').reset()
      this.PettycashFrom.get('txtBankBranch').reset()
      this.PettycashFrom.get('lblBankAccountName').reset()
      this.PettycashFrom.controls['ddlBank'].clearValidators();
      this.PettycashFrom.get('Bankother').reset()
      this.PettycashFrom.get('ddlBank').markAsUntouched({ onlySelf: true });
    } else if (event == 2) {
      this.IsCheque = false
      let Transfer = this.DataBank.filter(data => data.Transfer == 'Y' && data.Company == comcode);
      this._DataBank = Transfer;
      if (this.lstData != null) {
        var bankBranch = this.getBankBranch(this.lstData[0].sVendorCode, this.lstData[0].sValue1)
        this.BankBranch = bankBranch;
        if (bankBranch.length > 0) {
          this.BankCode = bankBranch[0].BANK_KEY;
          var bankAcoount = this.masterBankAccountNo.filter(x => x.VENDOR_CODE == this.lstData[0].sVendorCode && x.BANK == bankBranch[0].BANK_KEY)
          if (this.lstData[0].sValue1 == "Y") {
            bankAcoount.push({ fullname: "N/A", VENDOR_CODE: null, BANK: null, BANK_ACCOUNT: "N/A", ACCOUNT_HOLDER_NAME: null })
          }
          if (bankAcoount.length > 0) {
            if (this.lstData[0].BANK_KEY === bankBranch[0].BANK_KEY) {
              this.BankAccountNo = bankAcoount;
            }
            else {
              this.BankAccountNo = [];
            }
          }
        }
      }
      this.PettycashFrom.get('txtBankBranch').enable()
      this.PettycashFrom.get('lblBankAccountName').enable()
      this.PettycashFrom.get('ddlBank').enable()
      this.PettycashFrom.controls['ddlBank'].setValidators(Validators.required);
      this.PettycashFrom.controls['ddlBank'].updateValueAndValidity();
      let vendorname = this.lstTreqiTm.filter(data => data.IsDelete == false)
      if (vendorname.length != 0) {
        let vName = vendorname.length == 0 ? null : vendorname[0].vName
        this.PettycashFrom.patchValue({ lblBankAccountName: vName })
      } else {
        this.PettycashFrom.patchValue({ lblBankAccountName: this.PettycashFrom.get('txtVendorName').value })
      }
    }
  }

  //clear all data in form
  async Clear() {
    this.IsEdit = false;
    this.IsOneTimeVendor = false
    let FieldValid = ['txtVendorCode', 'txtVendorName', 'txtTaxID', 'txtInvoice', 'txtTotalAmountVat'
      , 'txtInvoiceDate', 'txtVatAmount', 'ddlVatType', 'txtVendorCode_PX', 'txtVendorName_PX'
      , 'txtTaxID_PX', 'sCountryName', 'sProvName', 'sAmpName', 'sTumbonName'
      , 'sPostCode', 'sPhoneNumber', 'sFaxNumber', 'sVendorEmail', 'txtWHTOther', 'txtWHTOther2', 'txtAddress_PX'
    ];

    FieldValid.forEach(data => this.PettycashFrom.get(data).markAsUntouched());

    this.PettycashFrom.patchValue({
      cbVat: 1,
      txtVendorCode_PX: "",
      txtVendorName_PX: "",
      txtTaxID_PX: "",
      cbOffice_PX: 1,
      txtBranchCode_PX: "",
      txtAddress_PX: "",
      txtInvoice: "",
      txtTotalAmountInvoice: "",
      ddlUOM: 'THB',
      txtVatAmount: "",
      txtInvoiceDate: new Date(),
      ddlVatType: "",
      txtTotalAmountVat: null,
      ddlWithholdingTax: "",
      ddlWithholdingTax2: "",
      txtWHTOther: null,
      txtWHTOther2: null,
      txtWHTAmount: null,
      _txtWHTAmount: null,
      txtWHTAmount2: null,
      _txtWHTAmount2: null,
      nWHTBase: "",
      nWHTBase2: "",
      sCountryID: "213",
      sCountryName: "ประเทศไทย",
      sProvCode: null,
      sProvName: null,
      sAmpCode: null,
      sAmpName: null,
      sTumbonCode: null,
      sTumbonName: null,
      sPostCode: null,
      sPhoneNumber: null,
      sFaxNumber: null,
      sVendorEmail: null,
      sVendorAddress: null,
      IsOneTimeVendor: null,
    });

    this.checkOffice();
    this.checkOffice_PX();
    this.cbVATorWHT();
    this.onselectWGT(1, false);
    this.onselectWGT(2, false);
    this.ArrGL.clear();
    this.AddGL();
    this.DataIO.push([]);
    this.IsEdit = false;
    this.IsOneTimeVendor = false;
  }

  //set amount => Payment Method
  lastvat = 0; //เก็บtotal vatล่าสุด
  setAmount() {
    let total = 0;
    let vat = 0;
    let WGD = 0;
    let TotalAmount = 0;
    let lst = this.lstTreqiTm.filter(f => f.IsDelete == false && f.cVenderMaster == "N")
    let lstRow = this.rows.filter(f => f.del == false)
    for (var i = 0; i < lstRow.length; i++) {
      total = total + this.ConvertCurrentTonumber(lstRow[i].amount)
    }
    let sinvoiceno = [];
    for (var i = 0; i < lst.length; i++) {
      if (!sinvoiceno.includes(f => f == lst[i].invoice)) {
        sinvoiceno.push(lst[i].invoice)
        let _Vat = isNull(lst[i].VatAmount) == true ? 0.00 : this.ConvertCurrentTonumber(lst[i].VatAmount)
        let _Wht = isNull(lst[i].WithholdingVal) == true ? 0.00 : this.ConvertCurrentTonumber(lst[i].WithholdingVal)
        let _Wht2 = isNull(lst[i].WithholdingVal2) == true ? 0.00 : this.ConvertCurrentTonumber(lst[i].WithholdingVal2)
        _Vat = isNaN(_Vat) ? 0.00 : _Vat
        _Wht = isNaN(_Wht) ? 0.00 : _Wht
        _Wht2 = isNaN(_Wht2) ? 0.00 : _Wht2
        vat = vat + _Vat
        WGD = WGD + _Wht + _Wht2
      }
    }
    TotalAmount = (total + vat) - WGD;

    //if (!this.IsNoData) {
    //this.lastvat = vat;
    this.PettycashFrom.patchValue({
      lblGrandTotalIncluded: this.formatnumber(2, true, TotalAmount),
      lblGrandTotalExcludedVAT: this.formatnumber(2, true, total),
      lblGrandTotalVat: this.formatnumber(2, true, vat),
      lblGrandTotalWHD: this.formatnumber(2, true, WGD),
    })

  }



  //defaule approver
  onSelectApprover(event: TypeaheadMatch, index: string): void {
    switch (index) {
      case 'txtApprove1':
        this.PettycashFrom.patchValue({ nUserID1: event.item['UserID'] });
        break
      case 'txtApprove2':
        this.PettycashFrom.patchValue({ nUserID2: event.item['UserID'] });
        break;
    }
  }
  _NoResultVendor: boolean;
  NoResultVendorPX: boolean;
  NoResulttxtGL: boolean;
  NoResulttxtCostCenter: boolean;
  NoResulttxtIO: boolean;
  NoResulttxtApprove1: boolean;
  NoResulttxtApprove2: boolean;
  NoResultsCountry: boolean;
  NoResultsBankBranch: boolean;
  NoResultsBankAccountNo: boolean;
  NoResultsAmpName: boolean;
  NoResultsTumbonName: boolean;
  NoResultsProvName: boolean;
  NoResultsCountryName: boolean;

  //check NoResults autoconplete
  typeaheadNoResults(event: boolean, name: string): void {
    switch (name) {
      case 'txtCopyofRequestNo':
        this.noResult = event;
        break;
      case 'txtVendorCode':
        this._NoResultVendor = event;
        break;
      case 'txtVendorCode_PX':
        this.NoResultVendorPX = event;
        break;
      case 'txtApprove1':
        this.NoResulttxtApprove1 = event;
        break;
      case 'txtApprove2':
        this.NoResulttxtApprove2 = event;
        break;
      case 'txtBankBranch':
        this.NoResultsBankBranch = event;
        break;
      case 'txtBankAccountNo':
        this.NoResultsBankAccountNo = event;
        break;
      case 'sTumbonName':
        this.NoResultsTumbonName = event;
        break;
      case 'sAmpName':
        this.NoResultsAmpName = event;
        break;
      case 'sProvName':
        this.NoResultsProvName = event;
        break;
      case 'sCountryName':
        this.NoResultsCountryName = event;
        break;
    }
    //this.noResult = event;
  }
  optionOnBlur: any;
  // set empty value or defaule when NoResults by autoconplete
  typeaheadOnBlur(event: any, name: string): void {
    let Pass: boolean = true;
    switch (name) {
      case 'txtCopyofRequestNo':
        if (this.PettycashFrom.get('txtCopyofRequestNo').value != event.item.sRequestCode) {
          Pass = false;
        }
        if (Pass) {
          this.onSelectCopyReqNo(event);
        } else {
          this.PettycashFrom.patchValue({
            txtCopyofRequestNo: null,
          })
        }
        break;
      case 'txtVendorCode':
        let txtVD = this.PettycashFrom.get('txtVendorCode').value;
        if (txtVD) {
          if (txtVD == event.item.Full_Name || txtVD == event.item.VENDOR_CODE || txtVD == event.item.VENDORNAME) {
            Pass = true;
          } else {
            Pass = false;
          }

          if (Pass) {
            this.onSelectedVendor(event, name);
          } else {
            this.NoResultVendor(name)
          }
        }
        break;
      case 'txtVendorCode_PX':
        let txtVD_PX = this.PettycashFrom.get('txtVendorCode_PX').value;
        if (txtVD_PX) {


          if (txtVD_PX == event.item.Full_Name || txtVD_PX == event.item.VENDOR_CODE || txtVD_PX == event.item.VENDORNAME) {
            Pass = true;
          } else {
            Pass = false;
          }

          if (Pass) {
            this.onSelectedVendor(event, name);
          } else {
            this.IsOneTimeVendor = true //IsOneTimeVendor
            let field = ['txtVendorCode_PX', 'txtVendorName_PX', 'txtAddress_PX', 'txtTaxID_PX']
            field.forEach(data => this.PettycashFrom.get(data).enable());
            field.forEach(data => this.PettycashFrom.get(data).setValidators(Validators.required));
            this.PettycashFrom.patchValue({
              txtVendorName_PX: null,
              txtAddress_PX: null,
              txtTaxID_PX: null,
              sCountryName: "ประเทศไทย"
              , sCountryID: "213"
              , sProvCode: null
              , sProvName: null
              , sAmpCode: null
              , sAmpName: null
              , sTumbonCode: null
              , sTumbonName: null
              , sPostCode: null
              , sFaxNumber: null
              , sPhoneNumber: null
              , sVendorEmail: null
              , sVendorAddress: null
            })
          }
        }
        break;
      case 'txtApprove1':
        let app1 = this.PettycashFrom.get('txtApprove1').value;
        let app_1: any = [];
        if (this.DataApprove1) {
          app_1 = this.DataApprove1.filter(f => f.name == app1)
        }
        if (app_1.length != 0) {
          this.onSelectApprover(event, name);
        } else {
          this.ChkNoResult(name);
        }
        break;
      case 'txtApprove2':
        let app2 = this.PettycashFrom.get('txtApprove2').value;
        let app_2: any = [];
        if (this.DataApprove2) {
          app_2 = this.DataApprove2.filter(f => f.name == app2)
        }
        if (app_2.length != 0) {
          this.onSelectApprover(event, name);
        } else {
          this.ChkNoResult(name);
        }
        break;
      case 'sCountryID':
        if (this.NoResultsCountry) {
          this.PettycashFrom.patchValue({
            sCountryName: "ประเทศไทย"
            , sCountryID: "213"
            , sProvCode: null
            , sProvName: null
            , sAmpCode: null
            , sAmpName: null
            , sTumbonCode: null
            , sTumbonName: null
            , sPostCode: null
            , sFaxNumber: null
            , sPhoneNumber: null
            , sVendorEmail: null
            , sVendorAddress: null
          })
        } else {
          this.onSelecCountry(event);
        }
        break;
      case 'txtBankBranch':
        let bank = this.PettycashFrom.get('txtBankBranch').value;
        let _bank: any[] = [];
        if (this.BankBranch) {
          _bank = this.BankBranch.filter(f => f.NAME_OF_BANK == bank)
        }
        if (_bank) {
          if (_bank.length != 0) {
            this.onSelectBank(event);
          }
          else {
            this.PettycashFrom.patchValue({
              txtBankBranch: null,
              txtBankAccountNo: null
            })
            this.PettycashFrom.controls['txtBankAccountNo'].disable();
          }
        }
        else {
          this.PettycashFrom.patchValue({
            txtBankBranch: null,
            txtBankAccountNo: null
          })
          this.PettycashFrom.controls['txtBankAccountNo'].disable();
        }
        break;
      case 'txtBankAccountNo':
        let bank2 = this.PettycashFrom.get('txtBankAccountNo').value;
        let _bank2: any[] = [];
        if (this.BankAccountNo) {
          _bank2 = this.BankAccountNo.filter(f => f.BANK_ACCOUNT == bank2)
        }
        if (_bank2) {
          if (_bank2.length != 0) {
            this.onSelectBankAccountNo(event);
          }
          else {
            this.PettycashFrom.patchValue({
              txtBankAccountNo: null
            })
          }
        }
        else {
          this.PettycashFrom.patchValue({
            txtBankAccountNo: null
          })
        }
        break;
      case 'sTumbonName':
        let tum = this.PettycashFrom.get('sTumbonName').value;
        let _tum: any[] = [];
        if (this.DataTumbon) {
          _tum = this.DataTumbon.filter(f => f.sTumbonName == tum)
        }
        if (_tum.length == 0) {
          if (this.nCountryID == "213") {
            this.PettycashFrom.patchValue({
              sTumbonName: null
              , sTumbonCode: null
            })

          }
        }
        else {
          this.OnselectTumbon(event);
        }

        break;
      case 'sAmpName':
        let Amp = this.PettycashFrom.get('sAmpName').value;
        let _Amp: any[] = [];
        if (this.DataAmphur) {
          _Amp = this.DataAmphur.filter(f => f.sAmpName == Amp)
        }
        if (_Amp.length == 0 && this.nCountryID == "213") {
          this.PettycashFrom.patchValue({
            sAmpName: null
            , sAmpCode: null
          })
          this.DataTumbon = [];
        } else {
          this.OnChangeTumbon(event);
        }
        break;
      case 'sProvName':
        let prov = this.PettycashFrom.get('sProvName').value;
        let _prov: any[] = [];
        if (this.DataProvince) {
          _prov = this.DataProvince.filter(f => f.sProvname == prov)
        }
        if (_prov.length == 0 && this.nCountryID == "213") {
          this.PettycashFrom.patchValue({
            sProvName: null
            , sProvCode: null
          })
          this.DataAmphur = [];
        } else {
          if (event) {
            this.OnChangeAmphor(event);
          }

        }
        break;
      case 'sCountryName':
        if (this.NoResultsCountryName) {
          this.PettycashFrom.patchValue({
            sCountryName: "ประเทศไทย"
            , sCountryID: "213"
            , sProvCode: null
            , sProvName: null
            , sAmpCode: null
            , sAmpName: null
            , sTumbonCode: null
            , sTumbonName: null
            , sPostCode: null
            , sFaxNumber: null
            , sPhoneNumber: null
            , sVendorEmail: null
            , sVendorAddress: null
          })
        } else {
          this.onSelecCountry(event);
        }
        break;
    }

  }

  //check NoResults autoconplete GL
  NoresuleGL(event: boolean, name: string) {
    switch (name) {
      case 'G':
        this.NoResulttxtGL = event;
        break;
      case 'C':
        this.NoResulttxtCostCenter = event;
        break;
      case 'I':
        this.NoResulttxtIO = event;
        break;
    }
  }
  // set empty value or defaule when NoResults by autoconplete GL

  IsNotFill_IO = false;
  //check dup ArrGL in invoice
  OnChange_CheckDuplicateGCI(sGL, sCostCenter, sIO, _inx) {
    let Result = { IsPass: true, Msg: "" };
    //Case 1 เช็คจาก Array Invoice
    for (var i = 0; i < this.ArrGL.length; i++) {
      if (i != _inx) {//ตรวจสอบ Index ว่าต้องไม่เป็น Index กับตัวที่ Select
        let Isdelete = this.ArrGL.value[i].IsDelete;
        let _sGL = this.ArrGL.value[i].txtGL;
        let _sCostCenter = this.ArrGL.value[i].txtCostCenter;
        let _sIO = this.ArrGL.value[i].txtIO;
        if (!Isdelete) {
          if (this.IsNotFill_IO) {//IsNotFill_IO คือระบบไม่ต้องกรอก IO
            if (!_IsNullOrEmpty(sGL) && !_IsNullOrEmpty(sCostCenter)) {//เช็คแค่ GL,CostCenter
              if (sGL == _sGL && sCostCenter == _sCostCenter) {
                Result.IsPass = false;
                Result.Msg = this.SW.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
          else {
            if (sGL == _sGL && sCostCenter == _sCostCenter && sIO == _sIO) { //เช็คแค่ GL,CostCenter , IO
              Result.IsPass = false;
              Result.Msg = this.SW.BoxMsg.Desc_Invoice_GCI;
              return Result;
            }
          }
        }
      }
    }
    return Result;
  }

  //OnSelectGCI & filter IO
  OnBlurGCI(event: TypeaheadMatch, _inx, _sType) {
    let FromArray = this.PettycashFrom.get('ArrGL') as FormArray;
    let FromGroup = FromArray.at(_inx) as FormGroup;
    let Pass: boolean = true;
    let IsValue = "";
    try {
      switch (_sType) {
        case "G":
          if (event.item.GL_ACCOUNT_NO) {
            let sGL = (FromGroup.controls.txtGL.value).trim();
            let GL_ITEM = this.DataGL.filter(f => f.GL_ACCOUNT_NO == sGL || f.name == sGL || f.SHORT_TEXT == sGL);
            Pass = GL_ITEM.length > 0
            if (GL_ITEM.length > 0) {
              IsValue = GL_ITEM[0].GL_ACCOUNT_NO;
            }
          }
          else {
            Pass = false;
          }
          break;
        case "C":
          if (event.item.COST_CENTER) {
            let sCostCenter = (FromGroup.controls.txtCostCenter.value).trim();
            let CostCenter_ITEM = this.DataCostCenter.filter(f => f.COST_CENTER == sCostCenter || f.name == sCostCenter || f.DESCRIPTION == sCostCenter);
            Pass = CostCenter_ITEM.length > 0
            if (CostCenter_ITEM.length > 0) {
              IsValue = CostCenter_ITEM[0].COST_CENTER;
            }
          }
          else {
            Pass = false;
          }
          break;
        case "I":
          if (event.item.ORDER_NUMBER) {
            let sIO = (FromGroup.controls.txtIO.value).trim();
            let IO_ITEM = this.RawDataIO.filter(f => f.ORDER_NUMBER == sIO || f.name == sIO || f.DESCRIPTION == sIO);
            Pass = IO_ITEM.length > 0
            if (IO_ITEM.length > 0) {
              IsValue = IO_ITEM[0].ORDER_NUMBER;
            }
          }
          else {
            Pass = false;
          }
          break;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ txtGL: IsValue });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ txtCostCenter: IsValue });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ txtIO: IsValue });
          break;
      }
    }
    else {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ txtGL: "" });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ txtCostCenter: "" });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ txtIO: "" });
          break;
      }
    }
  }

  OnSelectGCI(event: TypeaheadMatch, _inx, _sType) {
    let FromArray = this.PettycashFrom.get('ArrGL') as FormArray;
    let sGL = FromArray.at(_inx).get("txtGL").value;
    let sCostCenter = FromArray.at(_inx).get("txtCostCenter").value;
    let sIO = FromArray.at(_inx).get("txtIO").value;

    let SP_GL = sGL.split('-');
    let SP_CCTR = sCostCenter.split('-');
    let SP_IO = sIO.split('-');

    let SE_GL = SP_GL.length > 1 ? (SP_GL[0] + "").trim() : sGL;
    let SE_CCTR = SP_CCTR.length > 1 ? (SP_CCTR[0] + "").trim() : sCostCenter;
    let SE_IO = SP_IO.length > 1 ? (SP_IO[0] + "").trim() : sIO;

    let _CHK = this.OnChange_CheckDuplicateGCI(SE_GL, SE_CCTR, SE_IO, _inx);
    if (false) {
    //if (!_CHK.IsPass) {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ txtGL: "" });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ txtCostCenter: "" });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ txtIO: "" });
          break;
      }
      this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, _CHK.Msg, function () { Swal.close(); });
    }
    else {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ txtGL: event.item.GL_ACCOUNT_NO });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ txtCostCenter: event.item.COST_CENTER });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ txtIO: event.item.ORDER_NUMBER });
          break;
      }
    }
  }

  _EdnLine: any;
  _EdnItem: any;
  _invoice: any;
  IsSetNoChangecbVat: boolean = false;
  //Edit data by invoice
  EditGL(nLine: any, nItem: any, Invoice: any) {
    this.IsEdit = true;
    this.IsSetNoChangecbVat = true
    //this.Clear();
    this._EdnLine = nLine;
    this._EdnItem = nItem;
    this._invoice = Invoice;
    this.ArrGL.clear();
    let _lstMaster = this.lstTreqiTm.filter(data => data.cVenderMaster == "M" && data.IsDelete == false)
    if (_lstMaster.length != 0) {
      this.PettycashFrom.patchValue({
        txtVendorCode: _lstMaster[0].vendor,
        txtVendorName: _lstMaster[0].vName,
        txtTaxID: _lstMaster[0].TaxID,
        cbOffice: _lstMaster[0].cbOffice,
        txtBranchCode: _lstMaster[0].BranchCode,
        txtAddress: _lstMaster[0].address,
      })
    }
    let _lstEdit: any[] = [];
    _lstEdit = this.lstTreqiTm.filter(data => data.nItem == nItem && data.IsDelete == false);
    this.currency = _lstEdit[0].currency;
    if (_lstEdit.length != 0) {
      if (_lstEdit[0].cVenderMaster == 'M') {
        this.PettycashFrom.patchValue({
          cbVat: _lstEdit[0].nInvoiceType,
          txtInvoice: _lstEdit[0].Invoice,
          txtTotalAmountInvoice: this.formatnumber(2, true, _lstEdit[0].TotalAmountInvoice),
          ddlUOM: _lstEdit[0].currency,
          txtVatAmount: _lstEdit[0].VatAmount == null ? null : this.formatnumber(2, true, _lstEdit[0].VatAmount),
          txtInvoiceDate: new Date(_lstEdit[0].dInvoice),
          ddlVatType: _lstEdit[0].Vattype,
          txtTotalAmountVat: this.formatnumber(2, true, _lstEdit[0].TotalAmountVat),
          ddlWithholdingTax: _lstEdit[0].WithholdingTax,
          ddlWithholdingTax2: _lstEdit[0].WithholdingTax,
          txtWHTOther: _lstEdit[0].WithholdingTax == "" ? null : this.formatnumber(2, true, _lstEdit[0].WHTOther),
          txtWHTOther2: _lstEdit[0].WithholdingTax2 == "" ? null : this.formatnumber(2, true, _lstEdit[0].WHTOther2),
          txtWHTAmount: _lstEdit[0].WithholdingVal == "" ? null : this.formatnumber(2, true, _lstEdit[0].WithholdingVal),
          _txtWHTAmount: _lstEdit[0].WithholdingVal == "" ? null : this.formatnumber(2, true, _lstEdit[0].WithholdingVal),
          txtWHTAmount2: _lstEdit[0].WithholdingVal2 == "" ? null : this.formatnumber(2, true, _lstEdit[0].WithholdingVal2),
          _txtWHTAmount2: _lstEdit[0].WithholdingVal2 == "" ? null : this.formatnumber(2, true, _lstEdit[0].WithholdingVal2),
          nWHTBase: _lstEdit[0].nWHTBase == "" ? null : this.formatnumber(2, true, _lstEdit[0].nWHTBase),
          nWHTBase2: _lstEdit[0].nWHTBase2 == "" ? null : this.formatnumber(2, true, _lstEdit[0].nWHTBase2),
        })
      } else {
        if (_lstEdit[0].nInvoiceType == 2) {
          this.PettycashFrom.get('ddlWithholdingTax').disable();
          this.PettycashFrom.get('ddlWithholdingTax2').disable();
        } else {
          this.PettycashFrom.get('ddlWithholdingTax').enable();
          this.PettycashFrom.get('ddlWithholdingTax2').enable();
        }
        this.PettycashFrom.patchValue({
          cbVat: _lstEdit[0].nInvoiceType,
          txtInvoice: _lstEdit[0].Invoice,
          txtTotalAmountInvoice: this.formatnumber(2, true, _lstEdit[0].TotalAmountInvoice),
          ddlUOM: _lstEdit[0].currency,
          txtVatAmount: _lstEdit[0].VatAmount == null ? null : this.formatnumber(2, true, _lstEdit[0].VatAmount),
          txtInvoiceDate: new Date(_lstEdit[0].dInvoice),
          ddlVatType: _lstEdit[0].Vattype,
          txtTotalAmountVat: this.formatnumber(2, true, _lstEdit[0].TotalAmountVat),
          ddlWithholdingTax: _lstEdit[0].WithholdingTax == null ? "" : _lstEdit[0].WithholdingTax,
          ddlWithholdingTax2: _lstEdit[0].WithholdingTax2 == null ? "" : _lstEdit[0].WithholdingTax2,
          txtWHTOther: _lstEdit[0].WithholdingTax == "" ? null : this.formatnumber(2, true, _lstEdit[0].WHTOther),
          txtWHTOther2: _lstEdit[0].WithholdingTax2 == "" ? null : this.formatnumber(2, true, _lstEdit[0].WHTOther2),
          txtWHTAmount: _lstEdit[0].WithholdingVal == null ? '0.00' : this.formatnumber(2, true, _lstEdit[0].WithholdingVal),
          _txtWHTAmount: _lstEdit[0].WithholdingVal == null ? '0.00' : this.formatnumber(2, true, _lstEdit[0].WithholdingVal),
          txtWHTAmount2: _lstEdit[0].WithholdingVal2 == null ? '0.00' : this.formatnumber(2, true, _lstEdit[0].WithholdingVal2),
          _txtWHTAmount2: _lstEdit[0].WithholdingVal2 == null ? '0.00' : this.formatnumber(2, true, _lstEdit[0].WithholdingVal2),
          nWHTBase: _lstEdit[0].nWHTBase == null ? '0.00' : this.formatnumber(2, true, this.ConvertCurrentTonumber(_lstEdit[0].nWHTBase)),
          nWHTBase2: _lstEdit[0].nWHTBase2 == null ? '0.00' : this.formatnumber(2, true, this.ConvertCurrentTonumber(_lstEdit[0].nWHTBase2)),
          txtVendorCode_PX: _lstEdit[0].vendor,
          txtVendorName_PX: _lstEdit[0].vName,
          txtTaxID_PX: _lstEdit[0].TaxID,
          cbOffice_PX: _lstEdit[0].cbOffice,
          txtBranchCode_PX: _lstEdit[0].BranchCode,
          txtAddress_PX: _lstEdit[0].address
        })
      }


      //check vendor onetime
      if (_lstEdit[0].IsOneTimeVendor) {
        this.IsOneTimeVendor = _lstEdit[0].IsOneTimeVendor
        this.IsOneTimeVendor = true;
        this.PettycashFrom.patchValue({
          sCountryID: _lstEdit[0].sCountryID
          , sCountryName: _lstEdit[0].sCountryName
          , sProvCode: _lstEdit[0].sProvCode
          , sProvName: _lstEdit[0].sProvName
          , sAmpCode: _lstEdit[0].sAmpCode
          , sAmpName: _lstEdit[0].sAmpName
          , sTumbonCode: _lstEdit[0].sTumbonCode
          , sTumbonName: _lstEdit[0].sTumbonName
          , sPostCode: _lstEdit[0].sPostCode
          , sPhoneNumber: _lstEdit[0].sPhoneNumber
          , sFaxNumber: _lstEdit[0].sFaxNumber
          , sVendorEmail: _lstEdit[0].sVendorEmail
          , sVendorAddress: _lstEdit[0].sVendorAddress
        })
        let field = ['txtVendorCode_PX', 'txtVendorName_PX', 'txtAddress_PX', 'txtTaxID_PX']
        field.forEach(data => this.PettycashFrom.get(data).enable());
        //this.OnChangeAmphor();
        //this.OnChangeTumbon();
      }
    }

    // set value to ArrGL
    let lstrow_Ed = this.rows.filter(data => data.nItem == nItem && data.Invoice == Invoice && data.del == false)
    for (var i = 0; i < lstrow_Ed.length; i++) {
      this.ArrGL.push(new FormGroup({
        txtGL: new FormControl(lstrow_Ed[i].GL, Validators.required),
        txtCostCenter: new FormControl(lstrow_Ed[i].costcenter, Validators.required),
        txtText: new FormControl(lstrow_Ed[i].desc, Validators.required),
        txtIO: new FormControl(lstrow_Ed[i].IO === null ? "Not Require IO (N/A)" : lstrow_Ed[i].IO, Validators.required),
        txtAmountExcludedVAT: new FormControl(lstrow_Ed[i].amount, Validators.required),
        IsDelete: new FormControl(false),
        nLine: new FormControl(lstrow_Ed[i].nLine),
        nItem: new FormControl(lstrow_Ed[i].nItem),
      }));
      //this.DataIO.push([]);
    }
    //await this.checkOffice();
    this.IsEdit = true;
    //this.cbVATorWHT();
    this.checkOffice_PX();
    if (_lstEdit[0].Vattype == "VZ") {
      this.setformforVatVZ();
    }
    //if (this.nStatus != 1 && this.nStatus != 3) {
    //  this.ArrGL.disable();
    //}
    this.checkOffice();
    this.onselectWGT(1, false); //set withholding Tax
    this.onselectWGT(2, false); //set withholding Tax
    this.cbVATorWHT();
    document.getElementById('dvVendor').scrollIntoView({ behavior: "smooth" });
    //if (!this.ResultPermission) {
    //  this.ArrGL.disable();
    //  this.IsEdit = false;
    //}
    //this.CalTotalAmount();
  }

  //if vat type = VZ when do this
  setformforVatVZ() {
    this.PettycashFrom.patchValue({ ddlVatType: 'VZ' })
    this.PettycashFrom.get('ddlVatType').disable();
    this.PettycashFrom.controls['ddlVatType'].clearValidators();
    this.PettycashFrom.get('ddlVatType').markAsUntouched();

    this.PettycashFrom.get('txtVatAmount').disable();
    this.PettycashFrom.controls['txtVatAmount'].clearValidators();
    this.PettycashFrom.get('txtVatAmount').markAsUntouched();
  }

  //Delete Invoice
  async DelGL(nLine: any, nItem: any) {
    let _This = this;
    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, function () {
      _This.rows.filter(data => data.nLine == nLine && data.nItem == nItem).forEach(data => data.del = true)
      let lstdel = _This.rows.filter(f => f.nItem == nItem && f.del == false);
      let Isdel = lstdel.length == 0 ? true : false;
      if (Isdel) {
        let lst = _This.lstTreqiTm.filter(f => f.nItem == nItem);
        lst[0].IsDelete = true;
      }
      _This.setAmount();
      _This.IsNoData = _This.rows.filter(data => data.del == false).length == 0 ? true : false;
      if (_This.IsNoData == true) {
        _This.PettycashFrom.get('ddlUOM').enable();
      }
      _This.rows = _.orderBy(_This.rows, ["nItem"], ["asc"]);
    }, function () { })

  }

  //SaveDraft
  lstSaveD: any[] = [];
  SaveDaft() {
    let duedate = new Date(this.PettycashFrom.get('dDue').value);
    let date = Intl.DateTimeFormat('en').format(duedate);
    this.lstTReq = [];
    this.lstSaveD = [];
    this.setMaster();
    let arrtax: any[] = [];
    let TaxID: string = null;
    this.lstTReq.push({
      nReqID: this.PettycashFrom.value['nReqID']
      , dDue: this.System._ParseDateToFormat(duedate, '')
      , dStartDate: this.System._ParseDateToFormat(this.Todate, '')
      , nReqUrgentDay: this.nUrgentDate
      , sComCode: this.PettycashFrom.value['sComCode']
      , nUserIDContact: this.PettycashFrom.value['nUserIDContact']
      , sComName: this.PettycashFrom.value['sComName']
      , txtContactName: this.PettycashFrom.value['txtContactName']
      , nContact: this.PettycashFrom.get('nContact').value
      , txtDate: this.PettycashFrom.value['txtDate']
      , txtunit: this.PettycashFrom.value['txtunit']
      , txtTel: this.PettycashFrom.value['txtTel']
      , txtEmail: this.PettycashFrom.value['txtEmail']
      , ddlTypeofPay: this.PettycashFrom.value['ddlTypeofPay']
      , txtCopyofRequestNo: this.PettycashFrom.value['txtCopyofRequestNo']
      , cbVat: this.PettycashFrom.value['cbVat']
      , _cbChequeType: this.PettycashFrom.value['_cbChequeType']
      , ddlBank: this.PettycashFrom.value['ddlBank']
      , lblBankAccountName: this.PettycashFrom.value['lblBankAccountName']
      , txtBankAccountNo: this.PettycashFrom.value['txtBankAccountNo']
      , txtBankBranch: this.BankCode
      , lblGrandTotalInvoice: this.PettycashFrom.value['lblGrandTotalIncluded']
      , lblGrandTotalExcludedVAT: this.PettycashFrom.value['lblGrandTotalVat']
      , lblGrandTotal: this.PettycashFrom.value['lblGrandTotalExcludedVAT']
      , lblGrandTotalWHD: this.PettycashFrom.value['lblGrandTotalWHD']
      , lblAlertMsg: this.PettycashFrom.value['lblAlertMsg']
      , txtApprove1: this.PettycashFrom.value['txtApprove1']
      , txtApprove2: this.PettycashFrom.value['txtApprove2']
      , chkApprove1: this.PettycashFrom.value['chkApprove1']
      , nUserID1: this.PettycashFrom.value['nUserID1']
      , nUserID2: this.PettycashFrom.value['nUserID2']
      , nStatusID: 1
      , VendorCode: this.lstTreqiTm.length == 0 ? null : this.lstTreqiTm[0].vendor
      , currency: this.PettycashFrom.get('ddlUOM').value
      , IsReqUrgent: this.IsReqUrgent
      , sBankOther: this.PettycashFrom.value['Bankother']
      , nReqtype: 40
      , sBU: this.PettycashFrom.controls["txtBU"].value
      , vendor: this.PettycashFrom.get('txtVendorCode').value
      , vName: this.PettycashFrom.get('txtVendorName').value
      , TaxID: this.PettycashFrom.get('txtTaxID').value
      , address: this.PettycashFrom.get('txtAddress').value
      , sComment: this.sComment
      , sCommentSSC: this.sCommentSSC
    })

    let _this = this;

    this.System.BlockUI();
    //set data to controllet
    this.lstSaveD.push({
      Treq: this.lstTReq
      , TreqIm: this.lstTreqiTm
      , TreqLn: this.rows
      , arrFile: ArrFile
    })
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })

    let ITEM = JSON.stringify(this.lstSaveD);
    this.http.post<any>(this.System.SiteName + 'api/PettyCash/SaveDB', ITEM, { headers })
      .subscribe(res => {
        _this.System.UnBlockUI();
        if (res.Status == _this.System.SysProcess.SessionExpired) {
          _this.System.SessionExpire();
        }
        else if (res.Status == _this.System.SysProcess.Success) {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_SaveComplete, function () {
            _this.router.navigate(['/home']);
            Clearuploadfile();
            //Swal.close();
          });
        }
        else {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, res.Msg, undefined);
        }
      }
      );

  }

  //setvalidateAllForm
  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  //#region Validate
  isFieldValid(field: string) {
    return !this.PettycashFrom.get(field).valid && this.PettycashFrom.get(field).touched;
  }

  isEmailValid(field: string) {
    let input = this.PettycashFrom.get('sVendorEmail').value;
    let checkEmail: boolean = false
    let Regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (Regex.test(input)) {
      checkEmail = true
    }
    return !this.PettycashFrom.get(field).valid && this.PettycashFrom.get(field).touched && checkEmail;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }
  isFieldValidTbGl(_Field: string, _inx) {
    let FromArray = this.PettycashFrom.get('ArrGL') as FormArray;
    return !FromArray.at(_inx).get(_Field).valid && FromArray.at(_inx).get(_Field).touched;
  }
  displayFieldCssTbGl(_Field: string, _inx) {
    return {
      'has-error': this.isFieldValidTbGl(_Field, _inx),
      'has-feedback': this.isFieldValidTbGl(_Field, _inx)
    }
  }
  //#endregion

  BankCode: any;
  //select Bank
  onSelectBank(event: TypeaheadMatch) {
    this.BankCode = event.item['BANK_KEY']
    this.PettycashFrom.patchValue({ txtBankBranch: event.item['NAME_OF_BANK'] })
    this.PettycashFrom.controls['txtBankAccountNo'].enable();
    var bankAcoount = this.masterBankAccountNo.filter(x => x.VENDOR_CODE == this.VendorCode && x.BANK == event.item['BANK_KEY'])
    if (event.item['BANK_KEY'] == "N/A") {
      this.PettycashFrom.patchValue({
        txtBankAccountNo: "N/A",
      })
    }
    else if (bankAcoount.length > 0) {
      this.PettycashFrom.patchValue({
        txtBankAccountNo: bankAcoount[0].BANK_ACCOUNT,
      })
    }
  }

  onSelectBankAccountNo(event: TypeaheadMatch) {
    this.PettycashFrom.patchValue({ txtBankAccountNo: event.item['BANK_ACCOUNT'] });
  }

  NoResultVendor(index: string) {
    if (index == "txtVendorCode") {
      this.PettycashFrom.patchValue({ txtVendorCode: null, txtVendorName: null, txtAddress: null, txtTaxID: null, txtBankBranch: null, txtBankAccountNo: null })
      this.PettycashFrom.get('txtBankAccountNo').disable();
    } else if (index == 'txtVendorCode_PX') {
      this.PettycashFrom.patchValue({ txtVendorCode_PX: null, txtVendorName_PX: null, txtAddress_PX: null, txtTaxID_PX: null })
    }
  }

  getBank(vendorCode) {
  var bankList = []
  this.masterBankAccountNo.filter(x => x.VENDOR_CODE == vendorCode).forEach((item, i) => {
    bankList.push(item.BANK)
  });
  var bankBranch = this.masterBankBranch.filter(x => bankList.includes(x.BANK_KEY))
  bankBranch.forEach((item, i) => {
    item.sort = bankList.indexOf(item.BANK_KEY)
  });
  bankBranch.sort((a, b) => a.sort - b.sort)
  if (this.lstData[0].sValue1 == "Y") {
    bankBranch.push({ fullname: "N/A", BANK_BRANCH: null, BANK_KEY: "N/A", CITY: null, COUNTRY: null, NAME_OF_BANK: "N/A", STREET: null, SWIFT: null })
  }
  return bankBranch;
}

  ChkNoResult(index: string) {
    if (index == "txtCopyofRequestNo") {
      this.PettycashFrom.patchValue({ txtCopyofRequestNo: null });
    } else if (index == "txtApprove1") {
      this.PettycashFrom.patchValue({ txtApprove1: null });
    } else if (index == "txtApprove2") {
      this.PettycashFrom.patchValue({ txtApprove2: null });
    } else if (index == "txtContactName") {
      this.PettycashFrom.patchValue({ txtContactName: null });
    }

  }
  setMaster() {
    let chkEmployee = this.lstTreqiTm.filter(f => f.cVenderMaster == "M" && f.IsDelete != true)
    if (chkEmployee.length != 0) {
      chkEmployee[0].vendor = this.PettycashFrom.get('txtVendorCode').value
      chkEmployee[0].vName = this.PettycashFrom.get('txtVendorName').value
      chkEmployee[0].TaxID = this.PettycashFrom.get('txtTaxID').value
      chkEmployee[0].address = this.PettycashFrom.get('txtAddress').value
      chkEmployee[0].cbOffice = this.PettycashFrom.get('cbOffice').value
      chkEmployee[0].BranchCode = this.PettycashFrom.get('txtBranchCode').value
      chkEmployee[0].currency = this.currency;
      chkEmployee[0].cVenderMaster = "M"
      chkEmployee[0].dInvoice = this.System._ParseDateToFormat(new Date(this.PettycashFrom.get('txtInvoiceDate').value), 'yyyy-MM-dd')
    }
  }
  //Save submit
  SaveSubmit() {
    let duedate = new Date(this.PettycashFrom.get('dDue').value);
    let date = Intl.DateTimeFormat('en').format(duedate);
    this.System.BlockUI();
    this.lstTReq = [];
    this.lstSaveD = [];
    this.setMaster();
    this.lstTReq.push({
      nReqID: this.PettycashFrom.value['nReqID']
      , dDue: this.System._ParseDateToFormat(duedate, '')
      , dStartDate: this.System._ParseDateToFormat(this.Todate, '')
      , nReqUrgentDay: this.nUrgentDate
      , sComCode: this.PettycashFrom.value['sComCode']
      , nUserIDContact: this.PettycashFrom.value['nUserIDContact']
      , sComName: this.PettycashFrom.value['sComName']
      , txtContactName: this.PettycashFrom.value['txtContactName']
      , nContact: this.PettycashFrom.get('nContact').value
      , txtDate: new Date
      , txtunit: this.PettycashFrom.value['txtunit']
      , txtTel: this.PettycashFrom.value['txtTel']
      , txtEmail: this.PettycashFrom.value['txtEmail']
      , ddlTypeofPay: this.PettycashFrom.value['ddlTypeofPay']
      , txtCopyofRequestNo: this.PettycashFrom.value['txtCopyofRequestNo']
      , cbVat: this.PettycashFrom.value['cbVat']
      , _cbChequeType: this.PettycashFrom.value['_cbChequeType']
      , ddlBank: this.PettycashFrom.value['ddlBank']
      , lblBankAccountName: this.PettycashFrom.value['lblBankAccountName']
      , txtBankAccountNo: this.PettycashFrom.value['txtBankAccountNo']
      , txtBankBranch: this.BankCode
      , lblGrandTotalInvoice: this.PettycashFrom.value['lblGrandTotalIncluded']
      , lblGrandTotalExcludedVAT: this.PettycashFrom.value['lblGrandTotalVat']
      , lblGrandTotal: this.PettycashFrom.value['lblGrandTotalExcludedVAT']
      , lblGrandTotalWHD: this.PettycashFrom.value['lblGrandTotalWHD']
      , lblAlertMsg: this.PettycashFrom.value['lblAlertMsg']
      , txtApprove1: this.PettycashFrom.value['txtApprove1']
      , txtApprove2: this.PettycashFrom.value['txtApprove2']
      , chkApprove1: this.PettycashFrom.value['chkApprove1']
      , nUserID1: this.PettycashFrom.value['nUserID1']
      , nUserID2: this.PettycashFrom.value['nUserID2']
      , nStatusID: 2
      , currency: this.currency
      , IsReqUrgent: this.IsReqUrgent
      , sBankOther: this.PettycashFrom.value['Bankother']
      , nReqtype: 40
      , sBU: this.PettycashFrom.controls["txtBU"].value
      , vendor: this.PettycashFrom.get('txtVendorCode').value
      , vName: this.PettycashFrom.get('txtVendorName').value
      , TaxID: this.PettycashFrom.get('txtTaxID').value
      , address: this.PettycashFrom.get('txtAddress').value
      , sComment: this.sComment
      , sCommentSSC: this.sCommentSSC
    })

    this.lstSaveD.push({
      Treq: this.lstTReq
      , TreqIm: this.lstTreqiTm
      , TreqLn: this.rows
      , arrFile: ArrFile
    })

    let _this = this
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    let ITEM = JSON.stringify(this.lstSaveD);

    this.http
      .post<any>(this.System.SiteName + 'api/PettyCash/SaveDB', ITEM, { headers })
      .subscribe(res => {
        _this.System.UnBlockUI();
        if (res.Status == _this.System.SysProcess.SessionExpired) {
          _this.System.SessionExpire();
        }
        else if (res.Status == _this.System.SysProcess.Success) {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_SaveComplete, function () {
            _this.router.navigate(['/home']);
            Clearuploadfile();
            //Swal.close();
          });
        }
        else {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, res.Msg, undefined);
        }
      });

  }
  //cancel Req No.
  OnCancel() {
    let _This = this
    this.http.get(this.System.SiteName + "api/PettyCash/CancelSubmit/" + this.ReqID + "/" + this.sComment).subscribe((data) => {
      let status = data
      this.System.UnBlockUI();
      if (status == "success") {
        this.SW.SwAlert.Success(this.SW.BoxMsg.Title_Success, this.SW.BoxMsg.Desc_Success_Delete, function () {
          _This.router.navigate(['/home'])
        });
      } else {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Error, function () { });
      }
    })

  }
  chkOther: boolean = false;
  //select payment type
  selectBank() {
    let bank = this.PettycashFrom.value['ddlBank']
    this.chkOther = bank.search('Other') != -1 ? true : false
    if (this.chkOther) {
      this.PettycashFrom.get('Bankother').enable()
    } else {
      this.PettycashFrom.get('Bankother').disable()
      this.PettycashFrom.get('Bankother').reset()
      this.PettycashFrom.patchValue({ Bankother: null })
    }
  }

  DataAmphur: any[] = [];
  //when event change province will filer Amphur in province
  OnChangeAmphor(event: TypeaheadMatch) {
    if (this.nCountryID == "213") {
      this.PettycashFrom.patchValue({
        sProvCode: event.item['sProvCode']
        , sProvName: event.item['sProvname']
        , sAmpCode: null
        , sAmpName: null
        , sTumbonCode: null
        , sTumbonName: null
      })
      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams().set("sProvCode", event.item['sProvCode'])
      };
      this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).subscribe(res => {
        this.DataAmphur = res == null ? [] : res;
      });
    } else {
      this.DataAmphur = [];
    }
  }

  //Tumbon
  DataTumbon: any[] = [];
  //when event change Amphur will filer Tumbon in Amphur
  OnChangeTumbon(event: TypeaheadMatch) {
    if (this.nCountryID == "213") {
      //let sAmpCode = this.PettycashFrom.value['sAmpCode'];
      this.PettycashFrom.patchValue({ sAmpCode: event.item['sAmpCode'], sAmpName: event.item['sAmpName'] })
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", event.item['sAmpCode'])
      };
      this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).subscribe(res => {
        this.DataTumbon = res
      });
    } else {
      this.DataTumbon = [];
    }
  }
  //#endregion

  OnselectTumbon(event: TypeaheadMatch) {
    this.PettycashFrom.patchValue({ sTumbonCode: event.item['sTumbonCode'], sTumbonName: event.item['sTumbonName'] })
  }
  IsCountryThai: boolean = true;
  nCountryID: string = "213"
  sCountry: string = "ประเทศไทย"
  //Country
  onSelecCountry(event: TypeaheadMatch): void {
    this.sCountry = event.item['sCountryName'];
    let sCountryID = event.item['sCountryID'];
    this.nCountryID = sCountryID + "";
    this.PettycashFrom.patchValue({ sCountryID: sCountryID, sCountryName: this.sCountry })
    //let sCountry = this.PettycashFrom.value['sCountryID'];
    if (sCountryID == "213") {
      this.IsCountryThai = true
      this.PettycashFrom.patchValue({
        sCountryID: event.item['sCountryID'],
        sCountryName: event.item['sCountryName'],
        sProvCode: null,
        sProvName: null,
        sAmpCode: null,
        sAmpName: null,
        sTumbonCode: null,
        sTumbonName: null,
        sPostCode: null,
        sPhoneNumber: null,
        sFaxNumber: null,
        sVendorEmail: null,
        sVendorAddress: null,
        IsOneTimeVendor: null,

      })
      this.GetAutocompleteProvince();
    } else {
      this.DataProvince = [];
    }

  }


  UserNoresults(event: boolean) {
    if (event) {
      this.PettycashFrom.patchValue({ nContact: null })
    }
  }
  //Flow process
  getFlowPro(index: any) {
    this.Iscomment = true;
    this.http.get<any>(this.System.SiteName + "api/PettyCash/GetFlowPro/" + encodeURIComponent(String(index))).subscribe(res => {
      if (res) {
        let Treq = res[0];
        if (Treq.nStatusID == 0 || Treq.nStatusID == 5 || Treq.nStatusID == 7 || Treq.nStatusID == 10) {
          this.sComment = Treq.sComment;
          this.PettycashFrom.patchValue({
            sComment: Treq.sComment,
          })
        }
      }

    });
  }
  //Vendor onetime
  CheckOnetimt() {
    let _this = this;
    let data = this.PettycashFrom.get('txtVendorCode_PX').value
    if (data.length > 10 && this.NoResultVendorPX) {
      this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.DescOneVendorLength, function () {
        _this.PettycashFrom.patchValue({ txtVendorCode_PX: data.substring(0, 10) })
      })
    }
  }
}
function _IsNullOrEmpty(str) {
  var Result = true;
  if (str && str != "null") {
    Result = false;
  }
  return Result;
}



